(function() {
  'use strict';

  angular
    .module('uclguide', [
        'ngAnimate',
        'ui.router',
        'ct.ui.router.extras',
        'ct.ui.router.extras.previous',
        'ct.ui.router.extras.statevis',
        'hj.gsapifyRouter',
        'com.2fdevs.videogular',
        'com.2fdevs.videogular.plugins.controls',
        'com.2fdevs.videogular.plugins.overlayplay',
        'com.2fdevs.videogular.plugins.poster',
        'com.2fdevs.videogular.plugins.buffering',
        'info.vietnamcode.nampnq.videogular.plugins.youtube',
        'mm.foundation',
        'snapscroll',
        'swipe',
        'angulartics.google.analytics',
        '720kb.socialshare',
        'reTree',
        'ng.deviceDetector',
        'ng.reponsive',
        'toastr']);

})();

(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('videoPlayerSeekbarPopup', videoPlayerSeekbarPopup)
        .directive('videoPopover', videoPopover)
        .directive('videoPopoverView', videoPopoverView)
        .factory('videoPopoverService',videoPopoverService)


    /** @ngInject */
    function videoPlayerSeekbarPopup($log, $sce, $timeout, VideoService,$compile) {
        return {
            restrict: 'E',
            //require: '^videoPlayerSeekbar',
            transclude: true,
            replace: true,
            scope:{
                cue:'=',
                position:'@'
            },
            templateUrl: 'app/components/videoplayer/videoplayerseekinfopopup.html',
            link:function ($scope,$element,$attr){
                $scope.style = $scope.position;
                var element = $compile('<div compile video-popover="cue.content" video-popover-trigger="mouseenter" video-popover-position="position"></div>')($scope);
                $element.append(element);
            }
        }
    }
    /** @ngInject */
    function videoPopoverService(){
        var obj = {
            popover:null,
            controller:null,
            content:null,
            position: [],
            status: false
        }

        obj.setContent = function($content){
            obj.content = $content
        }
        obj.show = function(){
            obj.status=true;
            obj.popover.show();
        }
        obj.hide = function(){
            obj.status= false;
            obj.popover.hide();
        }

        return obj;
    }

    /** @ngInject */
    function videoPopover($log, videoPopoverService) {
        return {
            restrict: 'A',
            scope:{
                videoPopover:'=',
                videoPopoverPosition: '=',
                videoPopoverTrigger:'@'
            },

            link:function ($scope,$element,$attr){

                $($element).on($scope.videoPopoverTrigger,function(){
                    $log.debug('pos',$scope.videoPopoverPosition)
                    videoPopoverService.setContent($scope.videoPopover);
                    videoPopoverService.position = $scope.videoPopoverPosition
                    videoPopoverService.show();

                })


                $($element).on('mouseleave',function(){
                    videoPopoverService.hide();
                })
            }
        }
    }
    /** @ngInject */
    function videoPopoverView($log, $timeout, videoPopoverService,$rootScope) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            templateUrl: 'app/components/videoplayer/videopopoverview.html',
            scope:{
                state:'='
            },
            controller: function(){
            },
            controllerAs:'main',
            link:function ($scope,$element,$attr){

                var vm = videoPopoverService.popover = $scope;
                var content = $element.find('.content');

                var status = false;

                var calculatePos = function(){

                    var ww =  $(window).width();
                    var cp =  (ww/100)*videoPopoverService.position;
                    var ew =  $($element).find('.content').width()/2;
                    var p = $($element).find('.pointer');


                    $($element).removeClass();
                    p.removeAttr('style');


                    if((cp+ew) > ww){
                        $($element).addClass('right-align')
                        $($element).find('.pointer').css('left',ew);
                       return  cp-ew;
                    }

                    if((cp-ew)<0){
                        $($element).addClass('left-align')
                        $($element).find('.pointer').css('left',-ew);
                        return  cp+ew;
                    }

                    $($element).addClass('middle-align')


                    checkY();
                    return cp;
                }

                var checkY = function(){
                    $log.debug('STATE',$scope.state);
                    if($scope.state==='open'){
                        var vh = $('.video-list').height();
                        //$($element).css('bottom',vh+20+'px');
                        TweenMax.to($element, 0.5,{bottom:vh+20});
                    }
                    else{
                        //$($element).css('bottom','65px');
                        TweenMax.to($element, 0.5,{bottom:65});
                    }
                }


                $(window).resize(function(){
                    calculatePos();

                },this);

                $timeout(function(){
                    TweenMax.set($element,{autoAlpha:0});

                    calculatePos();

                    vm.show = function(){
                        status=true;
                        TweenMax.set($element,{x: calculatePos()});
                        TweenMax.to($element, 0.5,{ autoAlpha: 1,onStart: function(){
                            if(!status){
                                status = true;
                            }
                        }});

                    }

                    vm.hide = function(){
                        TweenMax.to($element,0.5,{autoAlpha:0, onComplete:function(){
                            if(status){
                                status = false;
                            }
                        }});
                    }

                    $rootScope.$on('showTooltip',function(event,data){
                        $log.debug('SHOW',data.pos);
                        videoPopoverService.content = data.content;
                        videoPopoverService.position = data.pos;
                        data.active = true
                        videoPopoverService.show();
                    });

                    $rootScope.$on('hideTooltip',function(event,data){
                        $log.debug('hide',data);
                        data.active = false;
                        vm.hide();
                    });

                },0)


                $scope.$watch(function(){return $scope.state}, function(n,o){
                    checkY();
                })

                $scope.$watch(function(){return videoPopoverService.content}, function(n,o){
                    if(n!==null){
                        vm.header = n.title;
                        vm.content = n.body;
                    }
                })

            }
        }
    }
})();
(function(Draggable) {
    'use strict';

    angular
        .module('uclguide')
        .directive('videoPlayerSeekbar', videoPlayerSeekbar);

    /** @ngInject */
    function videoPlayerSeekbar($log, $state,$timeout, VideoService) {
        return {
            restrict: 'E',
            transclude: true,
            template: '<div id="seek-bar">' +
            '<div class="info-points-holder"><video-player-seekbar-popup ng-repeat="item in cuePoints" cue="item" position="{{item.pos}}"></video-player-seekbar-popup></div>' +
            '<ul class="dividers small-block-grid-{{main.videos.length}} small-padding"><li ng-repeat="video in main.videos"><img ng-src="assets/images/divider_seek.png" alt=""></li></ul>' +
            '<div class="track-bar"></div>' +
            '<div class="drag-button"></div>' +

            '</div>',
            controller: function(VideoService){

                var vm = this;

                vm.videos = VideoService.videos;

                $log.debug('scope.videos',vm.videos,vm.cuePoints);

                vm.getImageUrl = function($n){
                    return 'assets/images/video/'+$n;
                }
                vm.openVideo = function($id){
                    $state.go('app.video.item',{id:$id});
                }
            },
            controllerAs:'main',
            link:function ($scope,$element,$attri){
                var drag = $element.find('.drag-button');
                var bar = $element.find('.track-bar');
                var dragger;
                var seeking = false;

                $scope.cuePoints = VideoService.getVideoInfoPoints();
                Draggable.create(drag, {type:"x",  bounds:'#seek-bar'});


                var init = function(){
                    $log.debug('START INTERFACE')
                    dragger = Draggable.create(drag, {type:"x", cursor:"pointer", bounds:'#seek-bar',onDragStart:onStartSeek,onDrag:updateSeek,onDragEnd:updateAfterSeek});
                    setSeekPos(0);
                }

                var calcPer = function($x){
                    return (100/$element.find('#seek-bar').width())*$x;
                }

                var setCurrentMovie = function($pos){
                    var nm = VideoService.total;
                    var total = $element.find('#seek-bar').width();
                    var ml = total/nm;
                    var index = parseInt($pos/ml);
                    if(index!=VideoService.getCurrent()){
                        $timeout(function(){
                            $state.go('app.video.interface.item',{id:index});
                        },100);
                    }
                    else{
                        var percent = calcPer($pos);
                        $log.debug('seektoclip position',VideoService.getMovieSeekPos(percent));
                        VideoService.getPlayerAPI().seekTime(VideoService.getMovieSeekPos(percent),true);
                        VideoService.getPlayerAPI().play();
                    }
                }

                var  onStartSeek = function(){
                    seeking = true;
                    VideoService.getPlayerAPI().pause();
                }

                var updateSeek = function(e){
                    var pos = calcPer(e.x);
                    seeking=true;
                    setSeekPos(pos);

                }

                var updateAfterSeek = function(e){
                    //var pos = calcPer(e.x);
                    setCurrentMovie(e.x);
                    seeking = false;
                }

                var setSeekPos = function($progress,anim){
                    if(!anim){
                        bar.css({'width':$progress+'%'});
                    }
                    else{
                        TweenMax.to(bar,0.5,{width:$progress+'%',onStart:function(){
                        },ease:Power4.easeInOut})
                    }
                    if(!seeking){
                        var xpos= ($(window).width()/100)*$progress;
                        $(drag).css('transform','translateX('+parseInt(xpos-drag.width())+'px)');
                    }

                }

                $scope.$watch(function(){return VideoService.getSeekbarPos()}, function(n,o){
                    if(typeof n !== "undefined" && n !== null){
                        setSeekPos(VideoService.getSeekbarPos(),true);
                    }
                })


                init();

            }
        }
    }
})(Draggable);
(function() {
  'use strict';

  angular
    .module('uclguide')
    .directive('videoPlayerlistMobile', videoPlayerlistMobile)

  function videoPlayerlistMobile ($log,$state,$timeout,VideoService,deviceDetector,$rootScope){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/videoplayer/videoplayermobilelist.html',
      scope: {
        videoId: '='
      },
      controller: function ($scope) {
        var vm = this;
        vm.videos = VideoService.videos;

        vm.getImageUrl = function($n){
          return 'assets/images/video/'+$n;
        }

        vm.openVideo = function($id){
          $('.video-item').removeClass('current')
          $('#video_'+$id).addClass('visit')
          $('#video_'+$id).addClass('current')
          $state.go('app.video.interface.mobile',{id:$id});
        }

        vm.openInfo = function($id){
            $log.debug('CHECK INDEX', $id)
            $state.go('app.videoinfo',{hash:$id});
        }

      },
      controllerAs: 'main',
      link: function ($scope, $element, $attri) {

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
          $log.debug('app.video.interface.mobile',toState.name)
          if (toState.name === 'app.video.interface.mobile') {
            $('#content').addClass('no-scroll');
          }
          else{
            $('#content').removeClass('no-scroll');
          }
        })

      }
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('videoPlayerList', videoPlayerList);

    /** @ngInject */
    function videoPlayerList($log, $state, VideoService) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/videoplayer/videoplayerlist.html',
            controller: function(VideoService){
                var vm = this;
                vm.videos = VideoService.videos;

                vm.getImageUrl = function($n){
                    return 'assets/images/video/'+$n;
                }
                vm.openVideo = function($id){
                    $state.go('app.video.interface.item',{id:$id});
                }

            },
            controllerAs:'main',
            link:function ($scope,$element,$attri){

                var setCurrent = function(id){
                    $($element).find('.active').removeClass('active');
                    $('#video_bt_'+id).addClass('active');
                }

                $scope.$watch(function(){return VideoService.getCurrent()},function(n,o){
                    if(n!==o){
                        setCurrent(n)
                    }
                })

                setCurrent(0);

            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('videoPlayerInterface', videoPlayerInterface);

    /** @ngInject */
    function videoPlayerInterface($log, $state,$rootScope, VideoService,$timeout) {
        return {
            restrict: 'E',
            transclude: true,
            replace:true,
            templateUrl: 'app/components/videoplayer/videoplayerinterface.html',

            link: function(scope,element,attr){
                var vm = scope;
                var delay;
                var isOpen;

                vm.videoID = 0;

                var init = function(){
                    vm.videoID = VideoService.getCurrent();
                    vm.nclass = 'close';
                    vm.title = VideoService.getVideoCurrent().name;
                    isOpen = false;
                    TweenMax.set('#info-button',{autoAlpha:0});
                    TweenMax.set('.interface-holder', {y: $('.video-list').height()});
                    TweenMax.set('#info-button', {scaleX: 1, scaleY: 1, autoAlpha: 1});
                    TweenMax.set('.currentTitle',{y: 0, autoAlpha: 1});
                    $(window).resize();
                    TweenMax.to(element,1,{y:0,delay:0.5});

                }

                var openAnim = function(){
                    $timeout.cancel(delay);
                    vm.nclass = 'open';
                    if(!isOpen) {
                        isOpen = true;
                        TweenMax.to('.interface-holder', 0.5, {y: 0, overwrite: "all"});
                        TweenMax.to('#info-button', 0.2, {scaleX: 0.5, scaleY: 0.5, autoAlpha: 0});
                        TweenMax.to('.currentTitle', 0.8, {
                            y: $('.currentTitle').height() + 20,
                            autoAlpha: 0,
                            overwrite: "all"
                        });
                        $log.debug('OPEN')
                    }
                }

                var closeAnim = function(e){
                    delay = $timeout(function(){
                        if(isOpen) {
                            isOpen = false;
                            vm.nclass = 'close';
                            TweenMax.to('.interface-holder', 0.5, {
                                y: $('.video-list').height(), onStart: function () {
                                    vm.nclass = 'close';
                                }
                            });
                            TweenMax.to('#info-button', 0.5, {scaleX: 1, scaleY: 1, autoAlpha: 1});
                            TweenMax.to('.currentTitle', 0.5, {y: 0, autoAlpha: 1, overwrite: "all"});
                        }
                    },500);
                }

                scope.open = function(){
                    openAnim();
                }

                scope.close = function() {
                    closeAnim();
                }


                $(window).on('resize', function(){
                    if(vm.nclass === 'close'){
                        TweenMax.set('.interface-holder',{y:$('.video-list').height()});
                    }
                })
                TweenMax.set(element,{y:150});

                $timeout(function(){
                    init();
                },500);

                scope.openInfo = function(){
                    $state.go('app.videoinfo',{hash:vm.videoID});
                }

                $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, options){

                });

                scope.$watch(function(){return VideoService.getCurrent()},function(n,o){
                    if(n!==o){
                        vm.videoID = n;
                        vm.title = VideoService.getVideoCurrent().name;
                        VideoService.seekbarUpdate();
                    }
                })


            }

        }

    }
})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('videoPlayer', videoPlayer)
        .directive('videoPlayerControls', videoPlayerControls);

    /** @ngInject */
    function videoPlayerControls($log,$sce,$timeout,VideoService) {
        return {
            restrict: 'E',
            transclude: true,
            template: '<div ng-transclude></div>',
            link: function(scope,element,attrs){
                var controls = element.find('vg-controls')[0];
                var innerScope = angular.element(controls).isolateScope();

                var onplayHide = scope.$on('controls-hide', function(){
                    innerScope.hideControls();
                });

                scope.$destroy(function(){
                    onplayHide();
                })

            }
        }
    }

    /** @ngInject */
    function videoPlayer($log,$state,$timeout,VideoService,deviceDetector,$previousState,$rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/videoplayer/videoplayer.html',
            scope: {
                videoId: '='
            },
            controller: function($scope){
                var vm = this;
                $log.debug('IS MOBILE',deviceDetector.isPhoneOnly())
                if(deviceDetector.isPhoneOnly()){
                    vm.other = false;
                    vm.mobile = true;
                    vm.scalemode = 'contain'
                    var video = document.getElementsByTagName('video')[0];
                    var  onPlayerExitFullscreen = function(){
                        if($previousState.get()!== null){
                            $previousState.go();
                        }
                    }
                    video.addEventListener('webkitendfullscreen', onPlayerExitFullscreen, false);
                }
                else{
                    vm.other = true;
                    vm.mobile = false;
                    vm.scalemode = 'cover'
                }

                vm.onPlayerReady = function($API){
                    $log.debug('PLAYER READY --------------------------------')
                    $scope.API = $API;
                    VideoService.setPlayerAPI($scope.API);
                }

                vm.onCompleteVideo = function(){
                    if(!vm.mobile){
                        VideoService.setNext();
                        $state.go('app.video.interface.item',{id:VideoService.getCurrent()});
                    }

                }

                vm.onStateChange = function($state){
                    $log.debug('PLAYER STATE',$state)
                }

                vm.onUpdate = function($currentTime, $duration){
                    if(!vm.mobile) {
                        VideoService.seekbarUpdate($currentTime, $duration);
                    }
                }

                $rootScope.$on('gsapifyRouter:leaveStart', function(event){
                    $scope.API.pause();
                })


            },
            controllerAs: 'main',
            link:function ($scope,$element,$attri){

                var vm = this;
                var config;
                var controls;

                function initVideo(videoID) {
                    $log.debug('videoID', videoID)
                    var sources = [];
                    var videoData = VideoService.getVideoSourceById(videoID);

                    controls = angular.element($element.find('vg-controls')[0]).isolateScope();

                    return {
                        autoPlay: false,
                        sources: videoData.source,
                        preload: "auto",
                        transclude: true,
                        plugins: {
                            controls: {
                                autoHide: true,
                                autoHideTime: 1000
                            },
                            poster: "assets/images/video/" + videoData.poster

                        }
                    }
                }

                function start(){
                    $timeout(function () {
                        $scope.API.config = $scope.config;
                        $scope.API.play();
                        try{
                            controls.hideControls();
                        }
                        catch(e){
                            $log.debug('No controls')
                        }
                        $(window).resize();
                    }, 1500);
                }

                $scope.$on('gsapifyRouter:enterSuccess', function (event, element) {
                    //start();
                });


                $scope.$watch(function () {
                    return $scope.videoId
                }, function (n, o) {
                    if (typeof n !== "undefined" && n !== null) {
                        $scope.config = initVideo(n);
                        start();
                    }
                })


            }


        };

    }
})();
/*
 * vg-bkg-size
 * A Videogular plugin to emulate background-size CSS property for video: "cover" or "contain"
 *
 * Use:
 * <videogular vg-bkg-size="cover" center="true"></videogular>
 * vg-bkg-size => "cover" or "contain"
 * center => true or false
 *
 * Copyright (c) 2014 Panurge Web Studio
 * Licensed under the MIT license.
 */
( function( angular, undefined ) {

    'use strict';
    angular
        .module('uclguide')
        .directive( 'vgBkgSize', [ '$window','$log',
        function( $window , $log ) {

            return {
                restrict: 'A',
                require: '^videogular',

                link: function( $scope, elem, attrs, API ) {

                    console.log('API',API)

                    var videoHeight, videoWidth, inited = false,
                        mode = attrs.vgBkgSize === 'contain' ? 'contain' : 'cover',
                        center = attrs.center === false ? false : true;

                    // API extension
                    API.vgBkgSize = API.vgBkgSize || {};

                    API.vgBkgSize.update = function() {

                        console.log('UPDATE',inited)

                        if ( !inited ) {
                            return;
                        }

                        //var video = angular.element(API.mediaElement[ 0 ]);
                        // get native video size
                        videoHeight = 720;//video.height();
                        videoWidth = 1280;//video.width();
                        console.log('Update',API);

                        API.vgBkgSize.layout();

                    };

                    API.vgBkgSize.layout = function() {



                        if ( !inited ) {
                            return;
                        }

                        // get wrapper size
                        var containerH = angular.element(elem[ 0 ]).height(),
                            containerW = angular.element(elem[ 0 ]).width();



                        var newW, newH;

                        var ratio = videoWidth / videoHeight;

                        if ( mode === 'contain' ) {
                            if ( containerH / containerW > videoHeight / videoWidth ) {
                                newW = containerW;
                                newH = containerW / ratio;

                            } else {
                                newW = containerH * ratio;
                                newH = containerH;

                            }
                        } else if ( mode === 'cover' ) {

                            newW = containerH * ratio;
                            newH = containerW / ratio;


                            if (newH < containerH){
                                newW = containerH * ratio;
                                newH = containerH;
                            }

                            if (newW < containerW) {
                                newH = containerW / ratio;
                                newW = containerW;
                            }



                        };


                        angular.element(API.mediaElement[ 0 ]).css( {
                            'width': newW + 2,
                            'height': newH + 2, // +2 pixels to safely prevent empty spaces
                            'max-height': 'none',
                            'max-width': 'none'
                        } );


                        if ( center ) {
                            angular.element(API.mediaElement[ 0 ]).css( {
                                'margin-top': ( containerH - ( newH + 2 ) ) / 2,
                                'margin-left': ( containerW - ( newW + 2 ) ) / 2
                            } );
                        } else {
                            angular.element(API.mediaElement[ 0 ]).css( {
                                'margin-top': '',
                                'margin-left': ''
                            } );
                        }

                    }

                    attrs.$observe( 'vgBkgSize', function( nv, ov ) {
                        if ( nv !== ov ) {
                            mode = nv === 'contain' ? 'contain' : 'cover';
                            API.vgBkgSize.layout();
                        }
                    } );

                    attrs.$observe( 'center', function( nv, ov ) {
                        if ( nv !== ov ) {
                            center = $scope.$eval( nv ) === false ? false : true;
                            API.vgBkgSize.layout();
                        }
                    } );

                    $scope.$watch(
                        function() {
                            return API.isReady;
                        },
                        function( newVal, oldVal ) {
                            console.log('READY TO PLAY',newVal, oldVal)

                                if ( newVal === true ) {
                                    inited = true;
                                    API.vgBkgSize.update();
                                }
                                else{
                                    inited = false;
                                }

                        }
                    );


                    $scope.$on("$vgBkgSizeUpdate", API.vgBkgSize.update);
                    $scope.$on("$vgBkgSizeLayout", API.vgBkgSize.layout);

                    angular.element( $window ).on( 'resize', API.vgBkgSize.layout );
                }
            };
        }
    ] );

} )( window.angular );
(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('scrollIndicator', scrollIndicator)
        .directive('scrollIndicatorButton',scrollIndicatorButton);

    /** @ngInject */
    function scrollIndicator($log,$rootScope) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/scrollindicator/scrollindicator.html',
            transclude:true,
            replace:true,
            scope: {
                scrollData: '=',
                index: '='
            },
            controllerAs: 'vm',
            link: function($scope,$element,$attr){
                $scope.goto = function($i){
                    $scope.index=$i
                };
                $scope.$watch(function(){return $scope.index},function(n){
                    $log.debug('snap',n)
                })
            }
        };
        return directive;
    }
    /** @ngInject */
    function scrollIndicatorButton($log){
        return {
            restrict: 'E',
            template: '<li ng-mouseover="showPopover()" ng-mouseleave="hidePopover()"><a href="#" ></a>' +
            '<div class="orbit-caption" ng-show="popoverIsVisible"><span>{{ section }}</span></div>' +
            '<div class="orbit-right-triangle" ng-show="popoverIsVisible"></div></li>',
            scope: {
                section:'=',
                toggle: '@'
            },
            controller: function(){

            },
            link: function($scope,$element,$attr){

                $scope.showPopover = function() {
                    $scope.popoverIsVisible = true;
                };
                $scope.hidePopover = function () {
                    $scope.popoverIsVisible = false;
                };

            }
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .directive('preloaderView', preloaderView);

  /** @ngInject */
  function preloaderView($log,preloader,$rootScope) {
    return {
      restrict: 'A',
      link: function($scope,$element,$attr){

      }
    }
  }
})();
(function(){
    'use strict'
    angular
        .module('uclguide')
        .directive('directionIndicator',directionIndicator);

    /** @ngInject */
    function directionIndicator(responsiveService,deviceDetector){

        return {
            restrict: 'E',
            scope: {
                portrait: '=',
                landscape: '='
            },
            template:'<div ng-show="active" id="deviceDialog"><div class="msg" ng-include src="template"></div></div>',
            transclude: true,
            link: function (scope, element, attr) {

                scope.active = false;

                var checkOrientatation = function(n){
                    if(scope.portrait || !scope.landscape){
                        if(n === 'landscape'){
                            $('#app').addClass('hidden-for-small-up');
                            $(element).show();
                        }
                        else{
                            $('#app').removeClass('hidden-for-small-up');
                            $(element).hide();
                        }
                    }
                }

                if(deviceDetector.isMobile() && !deviceDetector.isTablet() && !deviceDetector.isDesktop()){

                    if(scope.portrait || !scope.landscape){
                        scope.template = 'app/components/orientation/landscape-overlay.html'
                    }

                    scope.active = true;
                    scope.$watch(function(){
                        return responsiveService('orientation')
                    }, function(n,o){
                        checkOrientatation(n)
                    })

                    $('body').on('resize', function(){
                        checkOrientatation(responsiveService('orientation'));
                    })

                    checkOrientatation(responsiveService('orientation'));

                }
                else{
                    scope.active = false;
                }


                scope.$on('$destroy', function(){
                })
            }
        }
    };

})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .directive('prevNext', prevNext);

    /** @ngInject */
    function prevNext($log,$state, VideoService,$timeout) {
        return {
            restrict: 'E',
            replace:true,
            template: '<div ng-mouseover="showNav()" ng-mouseenter="showNav()" ng-mouseout="hideNav()" id="{{ name }}" class="{{ position }}"><button class="button trans icon" ng-click="onToggle()" name="{{name}}" ><i class="ucl-{{position}}"></i></button></div>',
            scope: {
                type: '@'
            },
            link: function ($scope, $element, $attri) {
                if($scope.type ==='next'){
                    $scope.name = 'next'
                    $scope.position = 'right'
                }
                else{
                    $scope.name = 'prev'
                    $scope.position = 'left'
                }

                $scope.showNav = function(){
                    TweenMax.to(['#prev','#next'],0.5,{opacity:1,x:0});

                }

                $scope.hideNav = function(){
                    TweenMax.to(['#prev','#next'],0.5,{opacity:0})
                    TweenMax.to("#next",0.5,{x:50});
                    TweenMax.to("#prev",0.5,{x:-50});
                }

                $scope.onToggle = function(){
                    if($scope.type ==='next'){
                        VideoService.setNext();

                    }
                    else{
                        VideoService.setPrev();
                    }

                    $state.go('app.video.interface.item',{id:VideoService.getCurrent()});
                }

                $timeout(function(){
                    $scope.hideNav();
                },3000);

            }
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('uclguide')
    .directive('acmeNavbar', acmeNavbar)
    .directive('logoToggle', logoToggle);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($scope,$log,$state,$previousState) {
      var vm = this;
      $scope.goBack = function(){
        $log.debug('GO BACK',$previousState.get(),$state.current.name);
        if($previousState.get()!== null){
          $previousState.go();
        }
        else{
          if($state.current.name === 'app.videoinfo'){
            $state.go('app.video.interface.item');
            return;
          }
          if($state.current.name !== 'app.video.interface.mobile'){
            $state.go('app.intro');
          }
          else{
            $log.debug('goback to mobile')
            $state.go('app.video.interface.item');
          }
        }
      }
    }


  }
  /** @ngInject */
  function logoToggle($log,$rootScope,$state,$timeout){
    return {
      restrict: 'C',
      controller: function(){

      },
      link: function($scope,$element,$attr){

        $scope.white = true;
        $scope.black = false;

        $timeout(function(){
          checkButtons($state.current.name)
        },500);


        var checkButtons = function(name){
          $log.debug('$state',$state.current.name)
            switch(name){
              case 'app.videoinfo' :
                $scope.showprocedure= false;
                $scope.showclose= true;
                colorLogo ('b');
                break;
              case 'app.info' :
                $scope.showprocedure= false;
                $scope.showclose= true;
                break;
              case 'app.video.interface.mobile' :
                $scope.showprocedure= false;
                $scope.showclose= true;
                break;
              default :
                $scope.showprocedure= true;
                $scope.showclose= false;
                break;
            }
        }



        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
          $scope.showprocedure= false;
          $scope.showclose= false;
          if($state.current.name !== 'app.video.interface.item'){
            $scope.white = true;
            $scope.black = false;
          }
        });

        $rootScope.$on('gsapifyRouter:enterSuccess', function(event){
            checkButtons($state.current.name);
        })

        function colorLogo ($c){
          switch ($c){
            case 'w' :
            {
              $scope.white = true;
              $scope.black = false;
              break;
            }
            case 'b':
            {
              $scope.white = false;
              $scope.black = true;
              break;
            }
            default : {
              $scope.white = true;
              $scope.black = false;
            }
          }
        }

        $rootScope.$on('onLogoToggle', function(e,args){
          colorLogo (args.color);
        });



      }
    }
  }


})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
    'use strict';

    angular
        .module('uclguide')
        .factory('VideoService', VideoService);

    /** @ngInject */
    function VideoService($timeout,$log,$q,$http,contentUrl,$sce,$rootScope,deviceDetector) {

        var obj = {
            baseUrl:null,
            playerAPI:null,
            seekpos:0,
            videos: null,
            current: 0,
            cuePoints : [],
            total:null,
            currentDuration:0,
            dir: 1
        }

        obj.fetchContent = function(){
            var deferred = $q.defer();
            $log.debug(contentUrl);
            $http.get(contentUrl+'videos.json')
                .success(function(data) {
                    var v = angular.fromJson(data);
                    obj.baseUrl = v[0].videoBaseUrl;
                    obj.videos = v[0].videos;
                    obj.total = v[0].videos.length;
                    deferred.resolve(data);
                }).error(function(msg, code) {
                deferred.reject(msg);
                $log.error(msg, code);
            });
            return deferred.promise;
        }

        obj.getAllImages = function(){
            $log.debug('GET ALL IMAGES');
            var v =  obj.videos;
            var imageArray = [];


            angular.forEach(v, function(value, key) {
                $log.debug('v',value)
                if(!deviceDetector.isPhoneOnly()){
                    imageArray.push('assets/images/video/'+value.source.thumb);
                    imageArray.push('assets/images/video/'+value.source.image);
                }
                else{
                    imageArray.push('assets/images/video/'+value.source.mob);
                }
            })

            return imageArray;
        }

        obj.setPlayerAPI = function($api){
            obj.playerAPI = $api;
        }

        obj.getPlayerAPI = function(){
            if(obj.playerAPI!==null){
                return obj.playerAPI;
            }
        }

        obj.setCurrent = function($id){
            if($id.length===0){
                return null;
            }
            if($id <= (obj.total-1)){
                return obj.current = $id;
            }
            else{
                return null;
            }
        };

        obj.getCurrent = function(){
            return obj.current;
        }

        obj.setNext = function(){
            if(obj.current !== (obj.total-1)){
                obj.current ++
            }
            else{
                obj.current = 0;
            }
            obj.dir = 1;
        }

        obj.setPrev = function(){
            if(obj.current > 0){
                obj.current --;

            }
            else{
                obj.current = obj.total-1
            }
            obj.dir = 0;
        }

        obj.getVideoCurrent = function(){
            return obj.getVideoById(obj.current);
        }

        obj.getVideoById = function($id){
            if(obj.videos===null){
                return;
            }
            return obj.videos[$id]
        }

        obj.getVideoInfoById = function($id){
            var video =  obj.videos[$id];
            return video.info;
        }


        obj.getVideoSourceById = function($id){

            if(obj.videos===null){
                return;
            }
            var video =  obj.videos[$id];

            var videoData =  {
                source: [],
                poster:'',
            };

            var videoName = video.source.name;
            var type = video.source.type;
            var source = [];

            angular.forEach(type, function(value, key) {
                videoData.source.push({src:$sce.trustAsResourceUrl(obj.baseUrl+''+videoName+'.'+value),type:'video/'+value})
            });

            videoData.poster = video.source.image;

            $log.debug('video data',videoData)
            return videoData;
        }

        var calcPosition = function($id,$time,$duration){
            var t = obj.total;
            var range = 100/obj.total;
            var time = (range/100)*(parseInt((100/$duration)*$time));
            var pos = parseInt(((100/t)*$id)+time);

            return pos;
        }

        obj.getVideoInfoPoints = function(){

            if(obj.videos===null){
                return;
            }

            obj.cuePoints = [];
            var count=0;


            angular.forEach(obj.videos, function(value,key){

                var videoID = value.id;
                var duration = value.totalTime;

                angular.forEach(value.cue, function(value,key){
                    var temp = {
                        id:count++,
                        video:videoID,
                        content:value.content,
                        timeings: [value.start,value.end],
                        active:false,
                        pos: calcPosition(videoID,value.start,duration),
                        end: calcPosition(videoID,value.end,duration)
                    }

                    obj.cuePoints.push(temp);
                });
            })

            $log.debug('CUE POINTS',obj.cuePoints )

            return obj.cuePoints ;
        }

        obj.checkVideoInfoPoints = function($time){
            return $q(function(resolve,reject){
                angular.forEach(obj.cuePoints, function(value,key){
                    if(($time*10) >= value.pos && ($time*10) <= value.end){
                        if(!value.active){
                            resolve(value);
                        }
                    }
                    else{
                        if(value.active){
                            reject(value);
                        }
                    }
                })

            })
        }

        obj.seekbarUpdate = function($time,$duration){
            var time = 0
            obj.currentDuration = $duration;
            if(typeof $time !== 'undefined'){
                var range = 100/obj.total;
                time = (range/100)*(parseInt((100/$duration)*$time));
            }
            var c = obj.getCurrent();
            var t = obj.total;
            obj.seekpos = ((100/t)*c)+time;

            obj.checkVideoInfoPoints(obj.seekpos/obj.total).then(
            function(success){
                $log.debug('Video show',success.content.title);
                $rootScope.$broadcast('showTooltip',success);
            },
            function(reject){
                $log.debug('video hide',reject.content.title);
                $rootScope.$broadcast('hideTooltip',reject);
            });

            return obj.seekpos;
        }

        obj.getSeekbarPos = function(){
            return obj.seekpos;
        }

        obj.getMovieSeekPos = function($seek){
            var c = obj.getCurrent();
            var t = obj.total;
            var current = ((100/t)*c);

            var seek = ($seek-current)*10;
            $log.debug('SEEK',$seek,seek,current);
            return seek;
        }



        return obj;
    }
})();

(function() {
    'use strict';
    angular
        .module('ng.reponsive',[])
        .factory('responsiveService', responsiveService)
        .value('responsiveConfig', {
            sizes: [{
                name: 'tiny',
                minWidth: 0
            }, {
                name: 'small',
                minWidth: 640
            }, {
                name: 'medium',
                minWidth: 1024
            }, {
                name: 'large',
                minWidth: 1200
            }]
        })

    /** @ngInject */
    function responsiveService($window, $filter, $rootScope, responsiveConfig) {
        var opRegEx = /[<>]=?\s\w+/,
            forEach = angular.forEach,
            filter = angular.filter,
            sizes = responsiveConfig.sizes;

        sizes = $filter('orderBy')(sizes, '-minWidth');

        var getHeight = function() {
                return $window.innerHeight;
            },

            getWidth = function() {
                return $window.innerWidth;
            },

            getLabel = function() {
                var cWidth = getWidth(),
                    returnVal = false;
                for (var i = 0; i < sizes.length; i++) {
                    if (parseInt(cWidth) >= parseInt(sizes[i].minWidth)) {
                        return sizes[i].name;
                    }
                }
            },
            getWidthFromLabel = function(label) {
                return $filter('filter')(sizes, {
                    name: label
                }, true)[0]["minWidth"];
            },

            getTest = function(test) {
                var thingy = test.split(' ')[0],
                    against = test.split(' ')[1];

                if (isNaN(against)) {
                    return eval('(' + getWidth() + ' ' + thingy +  ' ' + getWidthFromLabel(against) + ')');
                } else {
                    return eval('(' + getWidth() + thingy + parseInt(against) + ')');
                }
            },

            getOrientation = function(){
                if(getHeight() > getWidth()) return 'portrait';
                else return 'landscape';
            };

        angular.element($window).on('resize', function() {
            $rootScope.$digest();
        });

        return function(onwha) {
            if (!onwha) {
                return getLabel();
            } else if (onwha == 'width') {
                return getWidth();
            } else if (onwha == 'height') {
                return getHeight();
            } else if (onwha == 'orientation') {
                return getOrientation();
            } else if (opRegEx.test(onwha)) {
                return getTest(onwha);
            } else {
                return (getLabel() == onwha);
            }
            return false;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .factory('preloader', preloader);


    function preloader($q, $rootScope){
        // I manage the preloading of image objects. Accepts an array of image URLs.
        function Preloader( imageLocations ) {
            // I am the image SRC values to preload.
            this.imageLocations = imageLocations;
            // As the images load, we'll need to keep track of the load/error
            // counts when announing the progress on the loading.
            this.imageCount = this.imageLocations.length;
            this.loadCount = 0;
            this.errorCount = 0;
            // I am the possible states that the preloader can be in.
            this.states = {
                PENDING: 1,
                LOADING: 2,
                RESOLVED: 3,
                REJECTED: 4
            };
            // I keep track of the current state of the preloader.
            this.state = this.states.PENDING;
            // When loading the images, a promise will be returned to indicate
            // when the loading has completed (and / or progressed).
            this.deferred = $q.defer();
            this.promise = this.deferred.promise;


        }
        // ---
        // STATIC METHODS.
        // ---
        // I reload the given images [Array] and return a promise. The promise
        // will be resolved with the array of image locations.
        Preloader.preloadImages = function( imageLocations ) {
            var preloader = new Preloader( imageLocations );
            return( preloader.load() );
        };
        // ---
        // INSTANCE METHODS.
        // ---
        Preloader.prototype = {
            // Best practice for "instnceof" operator.
            constructor: Preloader,
            // ---
            // PUBLIC METHODS.
            // ---
            // I determine if the preloader has started loading images yet.
            isInitiated: function isInitiated() {
                return( this.state !== this.states.PENDING );
            },
            // I determine if the preloader has failed to load all of the images.
            isRejected: function isRejected() {
                return( this.state === this.states.REJECTED );
            },
            // I determine if the preloader has successfully loaded all of the images.
            isResolved: function isResolved() {
                return( this.state === this.states.RESOLVED );
            },
            // I initiate the preload of the images. Returns a promise.
            load: function load() {
                // If the images are already loading, return the existing promise.
                if ( this.isInitiated() ) {
                    return( this.promise );
                }
                this.state = this.states.LOADING;
                for ( var i = 0 ; i < this.imageCount ; i++ ) {
                    this.loadImageLocation( this.imageLocations[ i ] );
                }
                // Return the deferred promise for the load event.
                return( this.promise );
            },
            // ---
            // PRIVATE METHODS.
            // ---
            // I handle the load-failure of the given image location.
            handleImageError: function handleImageError( imageLocation ) {

                this.errorCount++;
                // If the preload action has already failed, ignore further action.
                if ( this.isRejected() ) {
                    return;
                }
                this.state = this.states.REJECTED;
                this.deferred.reject( imageLocation );
            },
            // I handle the load-success of the given image location.
            handleImageLoad: function handleImageLoad( imageLocation ) {
                this.loadCount++;
                // If the preload action has already failed, ignore further action.
                if ( this.isRejected() ) {
                    return;
                }
                // Notify the progress of the overall deferred. This is different
                // than Resolving the deferred - you can call notify many times
                // before the ultimate resolution (or rejection) of the deferred.
                this.deferred.notify({
                    percent: Math.ceil( this.loadCount / this.imageCount * 100 ),
                    imageLocation: imageLocation
                });
                // If all of the images have loaded, we can resolve the deferred
                // value that we returned to the calling context.
                if ( this.loadCount === this.imageCount ) {
                    this.state = this.states.RESOLVED;
                    this.deferred.resolve( this.imageLocations );
                }
            },
            // I load the given image location and then wire the load / error
            // events back into the preloader instance.
            // --
            // NOTE: The load/error events trigger a $digest.
            loadImageLocation: function loadImageLocation( imageLocation ) {
                var preloader = this;
                // When it comes to creating the image object, it is critical that
                // we bind the event handlers BEFORE we actually set the image
                // source. Failure to do so will prevent the events from proper
                // triggering in some browsers.
                var image = $( new Image() )
                    .load(
                        function( event ) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    preloader.handleImageLoad( event.target.src );
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    preloader = image = event = null;
                                }
                            );
                        }
                    )
                    .error(
                        function( event ) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    preloader.handleImageError( event.target.src );
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    preloader = image = event = null;
                                }
                            );
                        }
                    )
                    .prop( "src", imageLocation )
                    ;
            }
        };
        // Return the factory instance.
        return( Preloader );
    }

})();
(function() {
'use strict';
angular.module("ng.deviceDetector", ["reTree"])
    .constant("BROWSERS", {
        CHROME: "chrome",
        FIREFOX: "firefox",
        SAFARI: "safari",
        OPERA: "opera",
        IE: "ie",
        MS_EDGE: "ms-edge",
        PS4: "ps4",
        VITA: "vita",
        UNKNOWN: "unknown"
    })
    .constant("DEVICES", {
        ANDROID: "android",
        I_PAD: "ipad",
        IPHONE: "iphone",
        I_POD: "ipod",
        BLACKBERRY: "blackberry",
        FIREFOX_OS: "firefox-os",
        CHROME_BOOK: "chrome-book",
        WINDOWS_PHONE: "windows-phone",
        PS4: "ps4",
        VITA: "vita",
        UNKNOWN: "unknown"
    })
    .constant("OS", {
        WINDOWS: "windows",
        MAC: "mac",
        IOS: "ios",
        ANDROID: "android",
        LINUX: "linux",
        UNIX: "unix",
        FIREFOX_OS: "firefox-os",
        CHROME_OS: "chrome-os",
        WINDOWS_PHONE: "windows-phone",
        PS4: "ps4",
        VITA: "vita",
        UNKNOWN: "unknown"
    })
    .constant("OS_VERSIONS", {
        WINDOWS_3_11: "windows-3-11",
        WINDOWS_95: "windows-95",
        WINDOWS_ME: "windows-me",
        WINDOWS_98: "windows-98",
        WINDOWS_CE: "windows-ce",
        WINDOWS_2000: "windows-2000",
        WINDOWS_XP: "windows-xp",
        WINDOWS_SERVER_2003: "windows-server-2003",
        WINDOWS_VISTA: "windows-vista",
        WINDOWS_7: "windows-7",
        WINDOWS_8_1: "windows-8-1",
        WINDOWS_8: "windows-8",
        WINDOWS_10: "windows-10",
        WINDOWS_PHONE_7_5: "windows-phone-7-5",
        WINDOWS_PHONE_8_1: "windows-phone-8-1",
        WINDOWS_PHONE_10: "windows-phone-10",
        WINDOWS_NT_4_0: "windows-nt-4-0",
        UNKNOWN: "unknown"
    })

    .service("detectUtils", ["deviceDetector", "DEVICES", "BROWSERS", "OS",
        function (deviceDetector, DEVICES, BROWSERS, OS) {
            var deviceInfo = deviceDetector;

            this.isMobile = function () {
                return deviceInfo.device !== 'unknown';
            };

            this.isAndroid = function () {
                return (deviceInfo.device === DEVICES.ANDROID || deviceInfo.OS === OS.ANDROID);
            };

            this.isIOS = function () {
                return (deviceInfo.os === OS.IOS || deviceInfo.device === DEVICES.I_POD || deviceInfo.device === DEVICES.IPHONE);
            };
        }
    ])

    .factory("deviceDetector", ["$window", "DEVICES", "BROWSERS", "OS", "OS_VERSIONS","reTree",
        function ($window, DEVICES, BROWSERS, OS, OS_VERSIONS,reTree) {

            var OS_RE = {
                WINDOWS: {and: [{or: [/\bWindows|(Win\d\d)\b/, /\bWin 9x\b/]}, {not: /\bWindows Phone\b/}]},
                MAC: {and:[/\bMac OS\b/,{not:/Windows Phone/}]},
                IOS: {and: [{or: [/\biPad\b/, /\biPhone\b/, /\biPod\b/]}, {not: /Windows Phone/}]},
                ANDROID: {and:[/\bAndroid\b/,{not:/Windows Phone/}]},
                LINUX: /\bLinux\b/,
                UNIX: /\bUNIX\b/,
                FIREFOX_OS: {and: [/\bFirefox\b/, /Mobile\b/]},
                CHROME_OS: /\bCrOS\b/,
                WINDOWS_PHONE: {or:[/\bIEMobile\b/,/\bWindows Phone\b/]},
                PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
                VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
            };

            var BROWSERS_RE = {
                CHROME: {and:[{or: [/\bChrome\b/, /\bCriOS\b/]},{not:{or:[/\bOPR\b/,/\bEdge\b/]}}]},
                FIREFOX: /\bFirefox\b/,
                SAFARI: {and:[/^((?!CriOS).)*\Safari\b.*$/,{not:{or:[/\bOPR\b/,/\bEdge\b/,/Windows Phone/]}}]},
                OPERA: {or:[/Opera\b/,/\bOPR\b/]},
                IE: {or: [/\bMSIE\b/, /\bTrident\b/]},
                MS_EDGE: {or: [/\bEdge\b/]},
                PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
                VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
            };

            var DEVICES_RE = {
                ANDROID: {and:[/\bAndroid\b/,{not:/Windows Phone/}]},
                I_PAD: /\biPad\b/,
                IPHONE: {and: [/\biPhone\b/, {not:/Windows Phone/}]},
                I_POD: /\biPod\b/,
                BLACKBERRY: /\bblackberry\b/,
                FIREFOX_OS: {and: [/\bFirefox\b/, /\bMobile\b/]},
                CHROME_BOOK: /\bCrOS\b/,
                WINDOWS_PHONE: {or:[/\bIEMobile\b/,/\bWindows Phone\b/]},
                PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
                VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
            };

            var OS_VERSIONS_RE = {
                WINDOWS_3_11: /Win16/,
                WINDOWS_95: /(Windows 95|Win95|Windows_95)/,
                WINDOWS_ME: /(Win 9x 4.90|Windows ME)/,
                WINDOWS_98: /(Windows 98|Win98)/,
                WINDOWS_CE: /Windows CE/,
                WINDOWS_2000: /(Windows NT 5.0|Windows 2000)/,
                WINDOWS_XP: /(Windows NT 5.1|Windows XP)/,
                WINDOWS_SERVER_2003: /Windows NT 5.2/,
                WINDOWS_VISTA: /Windows NT 6.0/,
                WINDOWS_7: /(Windows 7|Windows NT 6.1)/,
                WINDOWS_8_1: /(Windows 8.1|Windows NT 6.3)/,
                WINDOWS_8: /(Windows 8|Windows NT 6.2)/,
                WINDOWS_10: /(Windows NT 10.0)/,
                WINDOWS_PHONE_7_5: /(Windows Phone OS 7.5)/,
                WINDOWS_PHONE_8_1: /(Windows Phone 8.1)/,
                WINDOWS_PHONE_10: /(Windows Phone 10)/,
                WINDOWS_NT_4_0: {and:[/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,{not:/Windows NT 10.0/}]}
            };

            var BROWSER_VERSIONS_RE_MAP = {
                CHROME:/\bChrome\/([\d\.]+)\b/,
                FIREFOX:/\bFirefox\/([\d\.]+)\b/,
                SAFARI:/\bVersion\/([\d\.]+)\b/,
                OPERA:[/\bVersion\/([\d\.]+)\b/,/\bOPR\/([\d\.]+)\b/],
                IE:[/\bMSIE ([\d\.]+\w?)\b/,/\brv:([\d\.]+\w?)\b/],
                MS_EDGE:/\bEdge\/([\d\.]+)\b/
            };

            var BROWSER_VERSIONS_RE = Object.keys(BROWSER_VERSIONS_RE_MAP).reduce(function (obj, key) {
                obj[BROWSERS[key]]=BROWSER_VERSIONS_RE_MAP[key];
                return obj;
            },{});

            var ua = $window.navigator.userAgent;

            var deviceInfo = {
                raw: {
                    userAgent: ua,
                    os: {},
                    browser: {},
                    device: {}
                }
            };

            deviceInfo.raw.os = Object.keys(OS).reduce(function (obj, item) {
                obj[OS[item]] = reTree.test(ua, OS_RE[item]);
                return obj;
            }, {});

            deviceInfo.raw.browser = Object.keys(BROWSERS).reduce(function (obj, item) {
                obj[BROWSERS[item]] = reTree.test(ua, BROWSERS_RE[item]);
                return obj;
            }, {});

            deviceInfo.raw.device = Object.keys(DEVICES).reduce(function (obj, item) {
                obj[DEVICES[item]] = reTree.test(ua, DEVICES_RE[item]);
                return obj;
            }, {});

            deviceInfo.raw.os_version = Object.keys(OS_VERSIONS).reduce(function (obj, item) {
                obj[OS_VERSIONS[item]] = reTree.test(ua, OS_VERSIONS_RE[item]);
                return obj;
            }, {});

            deviceInfo.os = [
                OS.WINDOWS,
                OS.IOS,
                OS.MAC,
                OS.ANDROID,
                OS.LINUX,
                OS.UNIX,
                OS.FIREFOX_OS,
                OS.CHROME_OS,
                OS.WINDOWS_PHONE,
                OS.PS4,
                OS.VITA
            ].reduce(function (previousValue, currentValue) {
                return (previousValue === OS.UNKNOWN && deviceInfo.raw.os[currentValue]) ? currentValue : previousValue;
            }, OS.UNKNOWN);

            deviceInfo.browser = [
                BROWSERS.CHROME,
                BROWSERS.FIREFOX,
                BROWSERS.SAFARI,
                BROWSERS.OPERA,
                BROWSERS.IE,
                BROWSERS.MS_EDGE,
                BROWSERS.PS4,
                BROWSERS.VITA
            ].reduce(function (previousValue, currentValue) {
                return (previousValue === BROWSERS.UNKNOWN && deviceInfo.raw.browser[currentValue]) ? currentValue : previousValue;
            }, BROWSERS.UNKNOWN);

            deviceInfo.device = [
                DEVICES.ANDROID,
                DEVICES.I_PAD,
                DEVICES.IPHONE,
                DEVICES.I_POD,
                DEVICES.BLACKBERRY,
                DEVICES.FIREFOX_OS,
                DEVICES.CHROME_BOOK,
                DEVICES.WINDOWS_PHONE,
                DEVICES.PS4,
                DEVICES.VITA
            ].reduce(function (previousValue, currentValue) {
                return (previousValue === DEVICES.UNKNOWN && deviceInfo.raw.device[currentValue]) ? currentValue : previousValue;
            }, DEVICES.UNKNOWN);

            deviceInfo.os_version = [
                OS_VERSIONS.WINDOWS_3_11,
                OS_VERSIONS.WINDOWS_95,
                OS_VERSIONS.WINDOWS_ME,
                OS_VERSIONS.WINDOWS_98,
                OS_VERSIONS.WINDOWS_CE,
                OS_VERSIONS.WINDOWS_2000,
                OS_VERSIONS.WINDOWS_XP,
                OS_VERSIONS.WINDOWS_SERVER_2003,
                OS_VERSIONS.WINDOWS_VISTA,
                OS_VERSIONS.WINDOWS_7,
                OS_VERSIONS.WINDOWS_8_1,
                OS_VERSIONS.WINDOWS_8,
                OS_VERSIONS.WINDOWS_10,
                OS_VERSIONS.WINDOWS_PHONE_7_5,
                OS_VERSIONS.WINDOWS_PHONE_8_1,
                OS_VERSIONS.WINDOWS_PHONE_10,
                OS_VERSIONS.WINDOWS_NT_4_0
            ].reduce(function (previousValue, currentValue) {
                return (previousValue === OS_VERSIONS.UNKNOWN && deviceInfo.raw.os_version[currentValue]) ? currentValue : previousValue;
            }, OS_VERSIONS.UNKNOWN);

            deviceInfo.browser_version = "0";
            if (deviceInfo.browser !== BROWSERS.UNKNOWN) {
                var re = BROWSER_VERSIONS_RE[deviceInfo.browser];
                var res = reTree.exec(ua,re);
                if (!!res) {
                    deviceInfo.browser_version = res[1];
                }
            }

            deviceInfo.isMobile = function () {
                return [
                    DEVICES.ANDROID,
                    DEVICES.I_PAD,
                    DEVICES.IPHONE,
                    DEVICES.I_POD,
                    DEVICES.BLACKBERRY,
                    DEVICES.FIREFOX_OS,
                    DEVICES.CHROME_BOOK,
                    DEVICES.WINDOWS_PHONE,
                    DEVICES.VITA
                ].some(function (item) {
                    return deviceInfo.device == item;
                });
            };

            deviceInfo.isTablet = function () {
                return [
                    DEVICES.I_PAD,
                    DEVICES.FIREFOX_OS,
                    DEVICES.CHROME_BOOK
                ].some(function (item) {
                    return deviceInfo.device == item;
                });
            };

            deviceInfo.isDesktop = function () {
                return [
                    DEVICES.PS4,
                    DEVICES.UNKNOWN
                ].some(function (item) {
                    return deviceInfo.device == item;
                });
            };

            deviceInfo.isPhoneOnly = function(){
                if(deviceInfo.isMobile() && !deviceInfo.isTablet() && !deviceInfo.isDesktop()){
                    return true;
                }
                else{
                    return false;
                }
            };

            return deviceInfo;
        }
    ])
    .directive('deviceDetector',  function (deviceDetector,$log,isMobile) {
        return {
            restrict: "A",
            link: function (scope, elm) {
                $log.debug('DEVICE',deviceDetector.os)
                elm.addClass('os-' + deviceDetector.os);
                elm.addClass('browser-' + deviceDetector.browser);
                elm.addClass('device-' + deviceDetector.device);

            }
        };
    });

})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, toastr,$rootScope) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1457173150123;
    vm.showToastr = showToastr;
    vm.currentDate = new Date();

    activate();
    $rootScope.$broadcast('onLogoToggle',{color:'w'});

    function activate() {
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .directive('infoContent', infoContent)

  /** @ngInject */
  function infoContent ($log,deviceDetector) {
    return {
      restrict: 'E',
      replace: true,
      transclude:true,
      templateUrl: 'app/info/infocontent.html',
      scope: {
        num:'=',
      },
      controller: function($scope,$rootScope){
        var vm = this;
        $scope.snapIndex=0;
        vm.isMobile = deviceDetector.isPhoneOnly();

        vm.inOutEasing = function(t, b, c, d){
          var ts=(t/=d)*t;
          var tc=ts*t;
          return b+c*(tc + -3*ts + 3*t);
        }

        vm.afterSnap = function($index){
          $log.debug('change logo',$index)
          $scope.snapIndex = $index;
          if(deviceDetector.isDesktop()){
            if($index == 0 || $index == 3){
              $rootScope.$broadcast('onLogoToggle',{color:'w'});
            }
            else{
              $rootScope.$broadcast('onLogoToggle',{color:'b'});
            }
          }else{
            if($index == 0){
              $rootScope.$broadcast('onLogoToggle',{color:'w'});
            }
            else{
              if(deviceDetector.isPhoneOnly()){
                $rootScope.$broadcast('onLogoToggle',{color:'w'});
              }
              else{
                $rootScope.$broadcast('onLogoToggle',{color:'b'});
              }
            }

          }


        }
        $scope.$watch(function(){return $scope.snapIndex},function(n){
          $log.debug('contoller snap',n)
          vm.snapIndex = n;
        })
      },
      controllerAs:'main',
      link: function ($scope, $element, $attri) {
        $scope.page = $scope.num;
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('uclguide')
    .controller('InfoController', InfoController)

  /** @ngInject */
  function InfoController($timeout,$log,$state,$scope,$previousState,$rootScope,$modal,deviceDetector) {

    var vm = this;

    vm.page = [
      {
        section:"Background",
        index:1
      },
      {
        section:"Symptoms & Signs",
        index:2
      },
      {
        section:"Radiographic features of osteoartritis",
        index:3
      },
      {
        section:"Indication for surgery",
        index:4
      },
      {
        section:"Risks of Surgery",
        index:5
      },
      {
        section:"Surgical approaches to the hip",
        index:6
      },
      {
        section:"Implants",
        index:7
      }
    ];

    vm.radiographic_features = [
      {
        img:"['assets/images/radiographic_feature_1.jpg, (small)'],['assets/images/radiographic_feature_1.jpg, (medium)'],['assets/images/radiographic_feature_1.jpg, (large)']",
        imgSource: 'assets/images/radiographic_feature_1.jpg',
        imgLarge:'assets/images/radiographic_feature_1_large.jpg',
        alt:'',
        desc:'Osteophyte formation'
      },
      {
        img:"['assets/images/radiographic_feature_2.jpg, (small)'],['assets/images/radiographic_feature_2.jpg, (medium)'],['assets/images/radiographic_feature_2.jpg, (large)']",
        imgSource: 'assets/images/radiographic_feature_2.jpg',
        imgLarge:'assets/images/radiographic_feature_2_large.jpg',
        alt:'',
        desc:'Subchondral cysts'
      },
      {
        img:"['assets/images/radiographic_feature_3.jpg, (small)'],['assets/images/radiographic_feature_3.jpg, (medium)'],['assets/images/radiographic_feature_3.jpg, (large)']",
        imgSource: 'assets/images/radiographic_feature_3.jpg',
        imgLarge:'assets/images/radiographic_feature_3_large.jpg',
        alt:'',
        desc:'Loss of joint space'
      },
      {
        img:"['assets/images/radiographic_feature_4.jpg, (small)'],['assets/images/radiographic_feature_4.jpg, (medium)'],['assets/images/radiographic_feature_4.jpg, (large)']",
        imgSource: 'assets/images/radiographic_feature_4.jpg',
        imgLarge:'assets/images/radiographic_feature_4_large.jpg',
        alt:'',
        desc:'Subchondral sclerosis'
      }
    ];

    vm.surgical_approaches = [
      {
        img:"['assets/images/feature-img-grey.jpg, (small)'],['assets/images/feature-img-grey.jpg, (medium)'],['assets/images/feature-img-grey.jpg, (large)']",
        imgSource: 'assets/images/feature-img-grey.jpg',
        alt:'Anterior (Smith-Peterson)',
        desc:'Anterior<br>(Smith-Peterson)',
        class: 'feature-info-grey'
      },
      {
        img:"['assets/images/feature-img-grey.jpg, (small)'],['assets/images/feature-img-grey.jpg, (medium)'],['assets/images/feature-img-grey.jpg, (large)']",
        imgSource: 'assets/images/feature-img-grey.jpg',
        alt:'Anterolateral (Watson-Jones)',
        desc:'Anterolateral<br>(Watson-Jones)',
        class: 'feature-info-grey'
      },
      {
        img:"['assets/images/feature-img-grey.jpg, (small)'],['assets/images/feature-img-grey.jpg, (medium)'],['assets/images/feature-img-grey.jpg, (large)']",
        imgSource: 'assets/images/feature-img-grey.jpg',
        alt:'Lateral (Hardinge)',
        desc:'Lateral<br>(Hardinge)',
        class: 'feature-info-grey'
      },
      {
        img:"['assets/images/feature-img-default.jpg, (small)'],['assets/images/feature-img-default.jpg, (medium)'],['assets/images/feature-img-default.jpg, (large)']",
        imgSource: 'assets/images/feature-img-default.jpg',
        alt:'Posterior',
        desc:'Posterior',
      }
    ];





    vm.openModal = function($img,$desc){
      $log.debug('STATE TEST ', $state);
      var modalInstance = $modal.open({
        template: '<div class="slide">'+
                  '<div class="slide-center"> <a class="close-reveal-modal" ng-click="cancel()"><button class="icon-border"><i class="ucl-close"></i></button></a>'+
                  '<img ng-src="{{ imageSrc }}">'+
                  '<p ng-bind-html="imageDesc"></p>'+
                  '</div>'+
                  '</div>',
        controller: function($scope,$modalInstance, item){
            $scope.imageSrc = item;
            $scope.imageDesc = $desc;
            $scope.cancel = function () {
              $modalInstance.dismiss('cancel');
            };
        },
        resolve: {
          item: function(){
            return $img;
          }

        }
      });
    }

    vm.openModalVideo = function($vid){

      var modalInstance = $modal.open({
        template: '<div class="slide">'+
                  '<div class="slide-center"><a class="close-reveal-modal" ng-click="cancel()"><button class="icon-border"><i class="ucl-close"></i></button></a>'+
                  '<iframe width="560" height="315" ng-src="{{ videoSrcUrl }}" frameborder="0" allowfullscreen></iframe>'+
                  '</div>'+
                  '</div>',
        controller: function($scope,$modalInstance, item, $sce){
          $scope.videoSrcUrl = $sce.trustAsResourceUrl(item);
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        },
        resolve: {
          item: function(){
            return $vid;
          }

        }
      });
    }
    $(window).scrollTop(0);
  }


})();

(function() {
    'use strict';

    angular
        .module('uclguide')
        .controller('InterfaceController', InterfaceController);

    /** @ngInject */
    function InterfaceController(VideoService,deviceDetector) {
        var vm = this;
        vm.videoID = VideoService.current;



        if(deviceDetector.isMobile() && !deviceDetector.isTablet() && !deviceDetector.isDesktop()){
            vm.mobile = true;
            vm.other = false;
        }
        else{
            vm.other = true;
            vm.mobile = false;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('uclguide')
        .controller('InfoVideoController', InfoVideoController);

    /** @ngInject */
    function InfoVideoController($scope, $stateParams, $timeout, $log,VideoService,$rootScope,deviceDetector,$state) {
        var vm = this;
        vm.videoID = VideoService.current;
        vm.videoInfo = VideoService.getVideoInfoById($stateParams.hash);

        $log.debug('$stateParams',vm.videoInfo )

        if(deviceDetector.isMobile() && !deviceDetector.isTablet() && !deviceDetector.isDesktop()){
            $rootScope.$broadcast('onLogoToggle',{color:'w'});
            $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
                $log.debug('STATE',toState);
                $log.debug('PARAM',toParams.hash);
                if(toState.name=='app.intro'){
                    vm.videoID = toParams.hash;
                }
            });
        }
        else{
            $rootScope.$broadcast('onLogoToggle',{color:'b'});
            $scope.$watch(function(){return VideoService.getCurrent()}, function(n,o){
                if(n!==o){
                    vm.videoID = n;
                }
            });
        }

        $scope.is = function(){
            return $state.is('app.videoinfo');
        };

    }
})();
(function() {
  'use strict';

  angular
    .module('uclguide')
    .controller('GuideController', GuideController);

  /** @ngInject */
  function GuideController($scope,$state,$stateParams,$timeout,$log,VideoService,deviceDetector) {
    var vm = this;
    vm.videoID;

    function startInterface(){

      $timeout(function(){
        if(deviceDetector.isMobile() && !deviceDetector.isTablet() && !deviceDetector.isDesktop()){
          vm.mobile = true;
          vm.other = false;
        }
        else{
          vm.other = true;
          vm.mobile = false;
        }

        if(VideoService.setCurrent($stateParams.id) !== null){
            vm.videoID = VideoService.setCurrent($stateParams.id);
        }
        else{

          if(!vm.mobile){
            $state.go('app.video.interface.item',{id:0})
          }
        }
      },0)
    }

    startInterface();

  }
})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');


  }

})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
          abstract:true,
        resolve:{
          contentData: function (VideoService) {
            console.log('content');
            return VideoService.fetchContent();
          }
        },
        controller: function($scope,contentData,VideoService,preloader){

           $scope.isLoading = true;
           $scope.isSuccessful = false;
           $scope.percentLoaded = 0;

          var imageLocations = VideoService.getAllImages();

          imageLocations.push('/assets/images/intro_bg.jpg');

          // Preload the images; then, update display when returned.
          preloader.preloadImages( imageLocations ).then(
            function handleResolve( imageLocations ) {
              // Loading was successful.
              $scope.isLoading = false;
              $scope.isSuccessful = true;
              console.info( "Preload Successful" );
            },
            function handleReject( imageLocation ) {
              // Loading failed on at least one image.
              $scope.isLoading = false;
              $scope.isSuccessful = false;
              console.error( "Image Failed", imageLocation );
              console.info( "Preload Failure" );
            },
            function handleNotify( event ) {
              $scope.percentLoaded = event.percent;
              console.info( "Percent loaded:", event.percent );
            }
          );

        },
        controllerAs: 'main'

      })
        .state('app.intro', {
            url: '/',
            views:{
                'content':{
                    templateUrl: 'app/main/main.html',
                    controller: 'MainController',
                    controllerAs: 'main'
                }
            },
            data: {

            }
        })
        .state('app.video', {
            url: '',
            abstract:true,
            sticky: true,
            views: {
                'content': {
                    templateUrl: 'app/guide/guide-main.html',
                }
            }
        })
        .state('app.video.interface', {
            url: '/video',
            abstract:true,
            sticky: true,
            views: {
                interface: {
                    templateUrl: 'app/guide/interface.html',
                    controller: 'InterfaceController',
                    controllerAs: 'main',
                }
            }
        })
        .state('app.video.interface.item', {
            url: '/:id',
            sticky: true,
            views:{
                videoplayer:{
                    templateUrl: 'app/guide/guide.html',
                    controller: 'GuideController',
                    controllerAs: 'main',
                }
            },
            data:{
                'gsapifyRouter.videoplayer': {
                    enter: {
                        in: {
                            transition:['VideoService', function(VideoService){
                                var trans = {};
                                if(VideoService.dir){
                                    trans = {
                                        duration: 1.5,
                                        delay: 0.2,
                                        ease: 'Quart.easeInOut',
                                        css: {
                                            x: '100%'
                                        }
                                    }
                                }
                                else{
                                    trans = {
                                        duration: 1.3,
                                            ease: 'Quart.easeInOut',
                                        css: {
                                            opacity: 0.5,
                                            z:-2,
                                            scale:0.7
                                    }
                                    }
                                }
                                return trans
                            }],
                            priority: 1
                        },
                        out: {}
                    },
                    leave: {
                        out: {
                            transition:['VideoService', function(VideoService){
                                var trans = {};
                                if(!VideoService.dir){
                                    trans = {
                                        duration: 1.3,
                                        ease: 'Quart.easeInOut',
                                        css: {
                                            x: '100%',
                                            z:1
                                        }
                                    }
                                }
                                else{
                                    trans = {
                                        duration: 1.5,
                                        ease: 'Quart.easeInOut',
                                        delay: 0.2,
                                        css: {
                                            opacity: 0.5,
                                            z:-2,
                                            scale:0.7
                                        }
                                    }
                                }

                                return trans
                            }],
                            priority: 1
                        }
                    }
                }

            }
        })
        .state('app.video.interface.mobile', {
          url: '/mobile/:id',
          views:{
              videoplayermobile:{
                  templateUrl: 'app/guide/guide.html',
                  controller: 'GuideController',
                  controllerAs: 'main',

              }
          },
          data:{
              'gsapifyRouter.videoplayermobile': {
                  enter: {
                      in: {
                          transition: {
                              duration: 1,
                              ease: 'Quart.easeInOut',
                              css: {
                                  opacity:0,
                                  scale: 0,
                              }
                          }
                      },
                      out: {},
                      priority: 1
                  },
                  leave:{
                    in:{},
                    out:{
                      transition: {
                        duration: 1,
                        ease: 'Quart.easeInOut',
                        css: {
                          opacity:0,
                          scale: 0,
                        }
                      }
                    }
                  }

              }

          }
      })
        .state('app.videoinfo', {
            url: '/info/:hash',
            views: {
                info: {
                    templateUrl: 'app/guide/infoVideo.html',
                    controller: 'InfoVideoController',
                    controllerAs: 'main',
                }
            },
            data: {
              'gsapifyRouter.info': {
                  enter: {
                    in: {
                          transition: {
                              duration: 1,
                                  ease: 'Quart.easeInOut',
                                  css: {
                                      y: '100%'
                                }
                          }
                      },
                      out: {},
                      priority: 1
                      },
                  leave:{
                    in:{},
                    out:{
                      transition: {
                        duration: 1,
                        ease: 'Quart.easeInOut',
                        css: {
                          y: '100%'
                        }
                      }
                    },
                    priority: 1
                  }
                }
            },

        })
        .state('app.info', {
          url: '/about-the-procedure',
          views:{
              'content':{
                  templateUrl: 'app/info/info.html',
                  controller: 'InfoController',
                  controllerAs: 'main'
              }
          },
            data: {
              'gsapifyRouter.content': {
                  enter: {
                    in: {
                          transition: {
                              duration: 1.2,
                                  ease: 'Quart.easeInOut',
                                  delay: 0.2,
                                  css: {
                                  y: '100%'
                              }
                          },
                        priority: 1
                      },
                    out: {
                        transition:{
                            duration: 1.2,
                            ease: 'Quart.easeInOut',
                            css: {
                                z:-2,
                                scale:0.7
                            }
                        },
                        priority: 1
                      },
                  },
                  leave: {
                      in: {
                          transition: {
                              duration: 1,
                              ease: 'Quart.easeInOut',
                              delay: 0.2,
                              css: {
                                z:-2,
                                scale:0.7
                              }
                          },
                        priority: 2
                      },
                      out:{
                          transition: {
                              duration: 1,
                              ease: 'Quart.easeInOut',
                              css: {
                                  y: '100%'
                              },
                            priority: 1
                          }
                      }
                  }

          }
      }


        });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('uclguide')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('contentUrl','/assets/content/')
    .constant('isMobile',false);

})();

(function() {
  'use strict';

  angular
    .module('uclguide')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig,gsapifyRouterProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;


    // Set default transitions to use if unspecified
    gsapifyRouterProvider.defaults = {
      // name of transition to use or 'none'
      enter: 'inAnim',
      leave: 'outAnim'
    };

    gsapifyRouterProvider.transition('inAnim', {
      duration: 1.2,
      ease: 'Quart.easeInOut',
      delay: 0.2,
      css: {
        y: '100%'
      }
    });

    gsapifyRouterProvider.transition('outAnim', {
      duration: 1.2,
      ease: 'Quart.easeInOut',
      css: {
        z:-2,
        scale:0.7
      }
    });

  }

})();

angular.module("uclguide").run(["$templateCache", function($templateCache) {$templateCache.put("app/info/info.html","<info-content num=\"main.page\" ng-cloak=\"\"><div id=\"header_1\"><div class=\"scroll-down\"><div class=\"holder\"><button class=\"icon-border\"><i class=\"ucl-scroll\"></i></button></div><span>Scroll Down</span></div><div class=\"row-half bg-primary small-text-center large-text-center\"><div class=\"slide row-padding\"><div class=\"slide-center\"><div class=\"row\"><div class=\"medium-8 medium-offset-2\"><h3>Mr John Skinner</h3><h4>Orthopaedic Surgeon</h4><div class=\"feature surgeon noPreventDefault\"><div class=\"feature-img\"><img alt=\"John Skinner\" interchange=\"[assets/images/john_skinner.png, (small)], [assets/images/john_skinner.png, (medium)], [assets/images/john_skinner.png, (large)]\" src=\"assets/images/john_skinner.png\" class=\"noPreventDefault\"></div></div><div class=\"quote\"><span><i class=\"ucl-quote\"></i></span>... it was termed ‘the operation of the 20th century’.</div></div></div></div></div></div><div class=\"row-half large-text-left columns\"><div class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"small-10 small-offset-1 medium-8 medium-offset-2\"><h1>Background</h1><p>Total hip replacement is rated as one of the most successful interventions in medicine. It offers reliable pain relief and can significantly improve function and quality of life for patients. The vast majority of total hip replacements are performed for osteoarthritis of the hip</p></div></div></div></div></div></div><div id=\"header_2\" class=\"slide\"><div class=\"slide-center\"><div class=\"row-img\"><img alt=\"Symptoms & Signs\" interchange=\"[assets/images/symptoms_signs_small.jpg, (small)], [assets/images/symptoms_signs_medium.jpg, (medium)], [assets/images/symptoms_signs_medium.jpg, (large)]\" src=\"assets/images/symptoms_signs_small.jpg\"></div><div class=\"row\"><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 large-4 large-offset-1 large-text-left columns\"><h1>Symptoms & Signs</h1><p>Patients with symptomatic hip arthritis suffer with a combination of pain and stiffness of the hip. Pain is classically felt within the groin, radiating through to the buttock or down the anterior thigh. The hip becomes increasingly stiff, so that activities such as putting on shoes and socks / attending to pedicure become increasingly difficult. Patients may start to experience night pain, walking distance is decreased and overall quality of life is negatively affected.</p></div><div class=\"large-6 large-text-left columns\"></div></div></div></div><div id=\"header_3\" class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 small-text-center columns\"><h1>Radiographic features of Osteoartritis</h1><h2>The four cardinal signs of osteoarthritis are:</h2><ul class=\"small-block-grid-2 medium-block-grid-4\"><li ng-repeat=\"item in main.radiographic_features\" class=\"feature\" ng-click=\"main.openModal(item.imgLarge,item.desc)\"><div class=\"feature-img\"><img alt=\"{{ item.desc }}\" interchange=\"{{ item.img }}\" ng-src=\"{{ item.imgSource }}\" class=\"noPreventDefault\"> <button class=\"icon-border noPreventDefault\"><i class=\"ucl-plus noPreventDefault\"></i></button></div><p ng-bind-html=\"item.desc\"></p></li></ul></div></div></div></div><div id=\"header_4\" class=\"slide\"><div class=\"slide-center\"><div class=\"row-img\"><img alt=\"Indications for surgery\" interchange=\"[assets/images/indications_for_surgery_small.jpg, (small)], [assets/images/indications_for_surgery_medium.jpg, (medium)], [assets/images/indications_for_surgery_medium.jpg, (large)]\" src=\"assets/images/indications_for_surgery_small.jpg\"></div><div class=\"row\"><div class=\"large-6 empty-col columns\"></div><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 end large-4 large-offset-1 large-text-left columns\"><h1>Indications for surgery</h1><p>Total hip replacement surgery is indicated for patients with symptomatic arthritis of the hip which is having a negative affect on their quality of life, and where conservative measures have failed.</p></div></div></div></div><div id=\"header_5\" class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 small-text-center columns\"><h1>Risks of surgery</h1><h2>The risks of total hip replacement are all low but can be very significant, requiring further surgeries, and hence should be discussed with the patient in detail as part of obtaining informed consent. Such risks include:</h2><ol class=\"risk-list small-block-grid-2 medium-block-grid-3 large-block-grid-4\"><li><span>Bleeding, - possibly requiring blood transfusion</span></li><li><span>Infection, - risk of deep infection approximately 1%, - very serious</span></li><li><span>DVT / PE</span></li><li><span>Hip dislocation</span></li><li><span>Leg length discrepancy</span></li><li><span>Peri-prosthetic fracture</span></li><li><span>Neurovascular injury, - especially sciatic nerve during posterior approach</span></li><li><span>Early failure / aseptic loosening</span></li></ol><a class=\"pdf-download\" href=\"assets/downloads/RNOH-THR-Patient-Information.pdf\" target=\"_blank\"><div class=\"icon-border\"><i class=\"ucl-download\"></i></div><span>Download</span></a></div></div></div></div><div id=\"header_6\" class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 small-text-center columns\"><h1>Surgical approaches to the hip</h1><h2>There are four main surgical approaches to the hip:</h2><ul class=\"small-block-grid-2 medium-block-grid-4\"><li ng-repeat=\"item in main.surgical_approaches\" class=\"feature noPreventDefault\"><div class=\"feature-img\"><img alt=\"{{ item.desc }}\" interchange=\"{{ item.img }}\" ng-src=\"{{ item.imgSource }}\" class=\"noPreventDefault\"><div class=\"feature-info {{ item.class }}\"><p ng-bind-html=\"item.desc\"></p></div></div></li></ul></div></div></div></div><div id=\"header_7\" class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"small-10 small-offset-1 medium-10 medium-offset-1 columns\"><h1>Implants</h1><h2>The Major tools used during hip replacement surgery:</h2><img alt=\"Implants\" interchange=\"[assets/images/implants_img.jpg, (small)], [assets/images/implants_img.jpg, (medium)], [assets/images/implants_img.jpg, (large)]\" src=\"assets/images/implants_img.jpg\"></div></div></div></div></info-content>");
$templateCache.put("app/info/infocontent.html","<div id=\"info\"><div ng-if=\"!main.isMobile\" class=\"info container white-bg\" snapscroll=\"\" after-snap=\"main.afterSnap(main.snapIndex)\" fit-window-height=\"\" snap-duration=\"1200\" scroll-delay=\"0\" snap-easing=\"main.inOutEasing\" snap-animation=\"snapAnimation\" snap-index=\"main.snapIndex\" ng-swipe-up=\"main.snapIndex=main.snapIndex+1\" ng-swipe-down=\"main.snapIndex=main.snapIndex-1\" ng-transclude=\"\"></div><div ng-if=\"main.isMobile\" class=\"info container white-bg\" ng-transclude=\"\"></div><scroll-indicator scroll-data=\"page\" index=\"main.snapIndex\" ng-if=\"page\"></scroll-indicator></div>");
$templateCache.put("app/guide/guide-main.html","<div ui-view=\"interface\"></div>");
$templateCache.put("app/guide/guide.html","<div class=\"container\"><video-player video-id=\"main.videoID\" ng-if=\"main.videoID\"></video-player></div>");
$templateCache.put("app/guide/infoVideo.html","<div class=\"info-video container white-bg\"><div class=\"slide\"><div class=\"slide-center\"><div class=\"row\"><div class=\"large-9 small-10 small-offset-1 medium-centered columns\"><h1>{{ main.videoInfo.header }}</h1><h2 class=\"color-black\">{{ main.videoInfo.desc }}</h2></div></div></div></div></div>");
$templateCache.put("app/guide/interface.html","<div id=\"interface\"><div class=\"other\" ng-if=\"main.other\"><prev-next type=\"prev\"></prev-next><prev-next type=\"next\"></prev-next><video-player-interface></video-player-interface><div ui-view=\"videoplayer\" class=\"gsapify-router\" autoscroll=\"false\"></div></div><div class=\"mobile\" ng-if=\"main.mobile\"><video-playerlist-mobile></video-playerlist-mobile><div ui-view=\"videoplayermobile\" class=\"video-mobile fixed-it gsapify-router\" autoscroll=\"false\"></div></div></div>");
$templateCache.put("app/main/main.html","<div id=\"intro\" class=\"container intro_bg\"><div class=\"slide\"><div class=\"slide-center\"><section><div class=\"row\"><div class=\"small-10 small-offset-1 large-8 large-offset-1 large-text-left columns\"><article><h1 class=\"large\">Uncemented<br>Total Hip Replacement</h1><h2 class=\"large\">Posterior Approach</h2><div id=\"interactive-guide\"><i class=\"icon-interactiveguide\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 610 65\" enable-background=\"new 0 0 610 65\" xml:space=\"preserve\"><g><path d=\"M203.9,20.7c-0.2-0.6-0.4-1.2-0.5-1.8c-0.2,0.7-0.3,1.3-0.5,1.8c-0.2,0.6-0.4,1.1-0.5,1.5l-5.6,14.6H210l-5.6-14.6 C204.2,21.8,204,21.3,203.9,20.7z\"></path><path d=\"M171.4,27.4c0.4-0.9,0.6-1.8,0.6-2.9c0-2.1-0.7-3.7-2.1-4.8c-1.4-1.1-3.5-1.6-6.3-1.6h-5.3v13.5h5.1c1.4,0,2.6-0.2,3.7-0.5 c1.1-0.3,2-0.8,2.7-1.5S171,28.3,171.4,27.4z\"></path><path d=\"M548.8,21.9c-1.1-1.2-2.4-2.1-4-2.8c-1.6-0.6-3.3-0.9-5.2-0.9H531v28h8.5c1.9,0,3.7-0.3,5.2-1c1.6-0.6,2.9-1.5,4-2.7 c1.1-1.2,2-2.7,2.5-4.4s0.9-3.7,0.9-5.9s-0.3-4.2-0.9-5.9S549.9,23.1,548.8,21.9z\"></path><path d=\"M0-0.5v65h610v-65H0z M22.7,50.1h-4.8V14.3h4.8V50.1z M67.1,50.1h-2.4c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.4-0.8-0.7 l-20.7-27c0,0.4,0.1,0.8,0.1,1.2s0,0.8,0,1.1v25.5h-4.2V14.3h2.5c0.2,0,0.4,0,0.5,0s0.3,0.1,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.2 c0.1,0.1,0.2,0.2,0.4,0.4l20.7,27c0-0.4-0.1-0.9-0.1-1.3c0-0.4,0-0.8,0-1.2V14.3h4.2V50.1z M106.7,18.4H95.1v31.8h-4.8V18.4H78.7 v-4.1h28V18.4z M140.4,50.1h-22.1V14.3h22.1v4h-17.2v11.9h14V34h-14v12.2h17.2L140.4,50.1z M175.6,50.1c-0.9,0-1.5-0.3-2-1 l-9.3-12.8c-0.3-0.4-0.6-0.7-0.9-0.9c-0.3-0.2-0.8-0.3-1.5-0.3h-3.7v15h-4.8V14.3h10.1c2.3,0,4.2,0.2,5.9,0.7c1.6,0.5,3,1.1,4.1,2 c1.1,0.9,1.9,1.9,2.4,3.1c0.5,1.2,0.8,2.6,0.8,4.1c0,1.3-0.2,2.4-0.6,3.5s-1,2.1-1.7,3s-1.7,1.6-2.8,2.2c-1.1,0.6-2.3,1.1-3.7,1.4 c0.6,0.4,1.2,0.9,1.6,1.5l10.4,14.2H175.6z M216.4,50.1c-0.4,0-0.8-0.1-1.1-0.3s-0.5-0.5-0.6-0.8l-3.3-8.6h-16.1l-3.4,8.6 c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.4-1.1,0.4h-3.8l14.3-35.8h4.9l14.3,35.8H216.4z M252.6,49.1c-2.1,1-4.6,1.4-7.6,1.4 c-2.6,0-4.9-0.4-7-1.3c-2.1-0.9-3.9-2.1-5.4-3.8s-2.6-3.5-3.4-5.8c-0.8-2.2-1.2-4.7-1.2-7.4s0.4-5.2,1.3-7.4s2-4.2,3.6-5.8 c1.5-1.6,3.4-2.9,5.5-3.8c2.1-0.9,4.5-1.3,7.1-1.3c2.6,0,4.8,0.4,6.8,1.2c2,0.8,3.7,1.9,5.1,3.3l-1.6,2.2c-0.1,0.2-0.2,0.3-0.4,0.4 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.7-0.2-1.1-0.5c-0.4-0.3-1-0.7-1.7-1.1c-0.7-0.4-1.6-0.8-2.6-1.1c-1-0.3-2.3-0.5-3.9-0.5 c-1.9,0-3.5,0.3-5.1,1s-2.9,1.6-4,2.8c-1.1,1.2-2,2.7-2.6,4.4c-0.6,1.8-0.9,3.7-0.9,5.9c0,2.2,0.3,4.2,1,6c0.6,1.8,1.5,3.2,2.6,4.4 c1.1,1.2,2.4,2.1,3.9,2.8c1.5,0.6,3.1,1,4.9,1c1.1,0,2-0.1,2.9-0.2s1.7-0.3,2.4-0.6c0.7-0.3,1.4-0.6,2-1s1.2-0.9,1.9-1.5 c0.3-0.2,0.6-0.4,0.9-0.4c0.3,0,0.5,0.1,0.7,0.3l1.9,2.1C256.5,46.8,254.7,48.1,252.6,49.1z M294,18.4h-11.6v31.8h-4.8V18.4H266 v-4.1h28V18.4z M310.4,50.1h-4.9V14.3h4.9V50.1z M340.4,50.1H336l-14.6-35.8h3.9c0.4,0,0.8,0.1,1,0.3c0.3,0.2,0.5,0.5,0.6,0.8 L337,40.7c0.2,0.6,0.4,1.2,0.6,1.9c0.2,0.7,0.4,1.4,0.6,2.1c0.2-0.7,0.3-1.4,0.5-2.1c0.2-0.7,0.4-1.3,0.6-1.9l10.1-25.3 c0.1-0.3,0.3-0.5,0.6-0.8c0.3-0.2,0.6-0.4,1.1-0.4h3.9L340.4,50.1z M388,50.1h-22.1V14.3H388v4h-17.2v11.9h14V34h-14v12.2H388 L388,50.1z M449.2,46.6c-1.8,1.3-3.7,2.3-5.8,2.9c-2,0.6-4.3,1-6.7,1c-2.9,0-5.5-0.4-7.8-1.3c-2.3-0.9-4.3-2.1-5.9-3.8 c-1.6-1.6-2.9-3.5-3.8-5.8s-1.3-4.7-1.3-7.4c0-2.7,0.4-5.2,1.3-7.5s2.1-4.2,3.7-5.8c1.6-1.6,3.5-2.9,5.8-3.7s4.8-1.3,7.6-1.3 c1.4,0,2.7,0.1,4,0.3c1.2,0.2,2.3,0.5,3.4,0.9c1,0.4,2,0.9,2.9,1.4c0.9,0.6,1.7,1.2,2.5,1.9l-1.4,2.2c-0.2,0.3-0.5,0.5-0.8,0.6 c-0.3,0.1-0.7,0-1.1-0.2c-0.4-0.2-0.9-0.5-1.4-0.9c-0.5-0.3-1.1-0.7-1.9-1c-0.7-0.3-1.6-0.6-2.6-0.8c-1-0.2-2.2-0.3-3.6-0.3 c-2,0-3.8,0.3-5.5,1c-1.6,0.7-3,1.6-4.2,2.8s-2,2.7-2.7,4.4c-0.6,1.7-0.9,3.7-0.9,5.9c0,2.2,0.3,4.3,1,6c0.6,1.8,1.6,3.3,2.8,4.5 c1.2,1.2,2.6,2.2,4.3,2.8c1.7,0.6,3.6,1,5.7,1c0.8,0,1.6,0,2.3-0.1c0.7-0.1,1.4-0.2,2.1-0.4c0.7-0.2,1.3-0.4,1.9-0.6 c0.6-0.3,1.2-0.6,1.9-0.9v-7.9h-5.6c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.4-0.3-0.7v-2.8h11V46.6z M491,36.1c0,2.1-0.3,4-1,5.8 s-1.6,3.3-2.8,4.6c-1.2,1.3-2.7,2.3-4.5,3c-1.8,0.7-3.8,1.1-5.9,1.1c-2.2,0-4.2-0.4-6-1.1c-1.8-0.7-3.3-1.7-4.5-3 c-1.2-1.3-2.2-2.8-2.8-4.6s-1-3.7-1-5.8V14.3h4.8V36c0,1.5,0.2,2.9,0.6,4.1c0.4,1.2,1,2.3,1.8,3.2c0.8,0.9,1.8,1.6,3,2.1 c1.2,0.5,2.5,0.8,4,0.8c1.5,0,2.8-0.2,4-0.8c1.2-0.5,2.2-1.2,3-2.1c0.8-0.9,1.4-2,1.8-3.2s0.6-2.6,0.6-4.1V14.3h4.8V36.1z M510.8,50.1h-4.8V14.3h4.8V50.1z M555.9,39.5c-0.8,2.2-2,4.1-3.6,5.7s-3.4,2.8-5.6,3.6c-2.2,0.9-4.6,1.3-7.2,1.3h-13.4V14.3h13.4 c2.6,0,5,0.4,7.2,1.3c2.2,0.9,4,2.1,5.6,3.6c1.5,1.6,2.8,3.5,3.6,5.7c0.9,2.2,1.3,4.6,1.3,7.3C557.2,34.9,556.8,37.3,555.9,39.5z M592.5,50.1h-22.1V14.3h22.1v4h-17.2v11.9h14V34h-14v12.2h17.2L592.5,50.1z\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></i></div><p>There are many different ways in which hip replacement surgery can be performed. In particular, all surgeons have different techniques, and may perform the relevant stages in different orders, to achieve the same goal. This teaching module brings you into theatre with global expert, Mr John Skinner, from the Royal National Orthopaedic Hospital in London, and aims to give you an overview as to his principles of hip replacement surgery through the posterior approach.</p><p><a href=\"#\" ui-sref=\"app.video.interface.item({id:0})\" class=\"begin\"><button class=\"icon-border\"><i class=\"ucl-play\"></i></button><span>BEGIN THE Procedure</span></a></p></article></div></div><footer><div class=\"row\"><div class=\"small-10 small-offset-1 large-text-left columns\"><div class=\"footer-row-half footer-info columns\">University College London, Gower Street, London WC1E 6BT<br>Copyright © {{ main.currentDate | date:\'yyyy\' }} UCL</div><div class=\"footer-row-half columns\"><div class=\"social-links large-text-right\"><a class=\"ucl-link\" href=\"http://www.ucl.ac.uk/\" target=\"_blank\">UCL.AC.UK</a> <a href=\"#\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-text=\"UCL - Corail / Pinnacle Total Hip Replacement\" socialshare-url=\"\"><button class=\"icon-border\"><i class=\"ucl-facebook\"></i></button></a> <a href=\"#\" socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"UCL - Corail / Pinnacle Total Hip Replacement\" socialshare-url=\"\"><button class=\"icon-border\"><i class=\"ucl-twitter\"></i></button></a> <a href=\"https://www.youtube.com/user/RNOHnhs\" target=\"_blank\"><button class=\"icon-border\"><i class=\"ucl-youtube\"></i></button></a></div></div></div></div></footer></section></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=\"row\"><div class=\"ucl-logo-container small-10 small-offset-1 large-10 large-offset-1 large-text-left columns\"><h1><a ng-href=\"#\" ui-sref=\"app.intro\"><div class=\"logo-toggle\"><i class=\"icon-logo logo-white\" ng-show=\"white\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 300 150\" enable-background=\"new 0 0 300 150\" xml:space=\"preserve\"><g><path d=\"M84.8,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0v0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2H84.8z\"></path><path d=\"M86.4,49v0.3c0,0,0,0,0,0l0,0l0,0l0,0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h1.9c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1 c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49H86.4z\"></path><path d=\"M79.4,49.3C79.4,49.3,79.4,49.3,79.4,49.3L79.4,49.3L79.4,49.3c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h1.9c0,0,0-0.2,0-0.2c0,0,0,0,0,0 h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0 c0,0,0,0,0,0V49h-1.8V49.3z\"></path><path d=\"M74.3,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0 c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0l0,0l-0.1,0 c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0 c0,0,0,0.1,0,0.2H74.3z\"></path><path d=\"M77.8,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0v0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2H77.8z\"></path><path d=\"M1.3,4v87.7l108.5,0c-0.8-0.6-1.6-1.2-2.3-1.9c-6.2-6-6.3-13-6.5-19.5v-37h19.8v38.9c0,2.6,0.1,5.4,2.3,7.5 c1.6,1.7,4,2.3,6.3,2.3c3.1,0,5.1-1.1,6.3-2.2c2.3-2.2,2.4-4.9,2.4-7.6V33.4H158v33.1c0,7.1,0,16.4-7.3,23.4 c-0.7,0.7-1.5,1.3-2.3,1.9h29.7c-8.7-6.3-12.8-16.8-12.8-26.9c0-16.7,11.2-33.8,32.4-33.8c9.5,0,18.5,3.4,25.1,10.1 c2.7,2.7,3.9,4.8,5.2,7.3l-16.6,8.2c-1.6-3.7-4.6-10.3-12.9-10.3c-4.3,0-7.1,2-8.4,3.4c-4.7,4.5-4.7,11.5-4.7,14 c0,9.3,3.5,18,13.2,18c9.2,0,12-8.1,12.7-10.2l16.8,8.1c-1.6,3-3.1,5.8-6.1,8.8c-1.3,1.3-2.7,2.4-4.2,3.4h18.2V33.3h19.7v46h25.6 v12.5l18.7,0V4H1.3z M75.3,43C75.3,43,75.4,43,75.3,43c0,0,0.2,0,0.2,0c0,0,0,0,0,0s0-0.1,0-0.2c0,0,0,0,0,0s0.1,0,0.2,0 c0,0,0,0,0,0v-0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0-0.2-0.1-1.8,0.8-3c0.7-1,1.6-1.5,2.1-1.7 c0-0.2,0.3-0.3,0.4-0.3c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0v-0.2c0,0,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.1v-1.2c0,0,0,0-0.1,0c0,0,0,0,0,0h0c0,0,0,0,0,0v-0.1 c0,0,0,0,0,0h0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1h0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0h0.1c0,0,0,0,0.1,0c0.2-0.2,0.4-0.4,0.4-0.4 c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0.1,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0.1-0.2,0.1-0.2h0c0,0,0.1,0.1,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0.2,0.3,0.4,0.4c0,0,0,0,0.1,0h0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0h0c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.1h0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0-0.1,0-0.1,0v1.2 c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1V37c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0.1 c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.4,0.1,0.5,0.3c0.5,0.2,1.4,0.7,2.1,1.7c0.8,1.2,0.8,2.8,0.8,3c0,0,0,0.1,0.1,0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0,0v0.2c0,0,0,0,0,0c0,0,0.2,0,0.2,0s0,0,0,0c0,0,0,0.2,0,0.2s0,0,0,0c0,0,0.2,0,0.2,0h0c0,0,0,0,0,0 c0,0,0,0.1,0,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.2c0,0.2-0.1,0.2-0.2,0.2v0.7c0,0.2,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0,0,0,0.7,0,0.7 l-4.9-1.1h0l-4.9,1.1c0,0,0-0.7,0-0.7c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2v-0.7c0,0-0.2,0-0.2-0.2c0-0.1-0.1-0.2-0.2-0.2 c0,0,0,0,0,0C75.3,43.2,75.3,43.1,75.3,43z M91.5,60.1l-22.5,0v-1.4h0.8v-1.4h0.8v-0.6c0,0,0,0,0,0c0,0,0-0.2,0-0.2c0,0,0,0,0,0 h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49 h-0.1c0,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.1-0.1L70,48.1c-0.1-0.2-0.3-0.1-0.3-0.1l0,0l0,0l-0.1-0.5c0,0,0,0,0-0.1 c0,0,10.7-2.3,10.7-2.3S91,47.3,91,47.3h0c0.1,0,0,0.1,0,0.1l-0.1,0.5l0,0l0,0c0,0-0.2,0-0.3,0.1L90.4,49c0,0,0,0-0.1,0 c-0.1,0-0.4,0-0.4,0h-0.1v0.3c0,0,0,0,0,0h0l0,0l0,0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h0v0.6h0.8v1.4h0.8V60.1z\"></path></g><g><path d=\"M0.7,105.6H6c1.2,0,2.1,0.1,2.7,0.3c0.8,0.2,1.6,0.7,2.1,1.3c0.6,0.6,1.1,1.4,1.4,2.3c0.3,0.9,0.5,2,0.5,3.4 c0,1.2-0.1,2.2-0.4,3c-0.4,1-0.9,1.9-1.5,2.5c-0.5,0.5-1.2,0.9-2,1.1c-0.6,0.2-1.5,0.3-2.5,0.3H0.7V105.6z M3.6,108v9.4h2.1 c0.8,0,1.4,0,1.7-0.1c0.5-0.1,0.9-0.3,1.2-0.6c0.3-0.3,0.6-0.7,0.8-1.4c0.2-0.6,0.3-1.5,0.3-2.6s-0.1-1.9-0.3-2.5s-0.5-1.1-0.8-1.4 s-0.8-0.6-1.3-0.7C6.9,108,6.1,108,4.9,108H3.6z\"></path><path d=\"M15.1,108.1v-2.5h2.7v2.5H15.1z M15.1,119.8v-10.3h2.7v10.3H15.1z\"></path><path d=\"M23.5,119.8l-4.2-10.3h2.9l1.9,5.3l0.6,1.8c0.1-0.4,0.2-0.7,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.9l2-5.3H30l-4.1,10.3H23.5z\"></path><path d=\"M31.7,108.1v-2.5h2.7v2.5H31.7z M31.7,119.8v-10.3h2.7v10.3H31.7z\"></path><path d=\"M36.3,116.9l2.7-0.4c0.1,0.5,0.4,0.9,0.7,1.2c0.4,0.3,0.9,0.4,1.5,0.4c0.7,0,1.2-0.1,1.6-0.4c0.2-0.2,0.4-0.4,0.4-0.7 c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.4-0.2-0.9-0.4c-2.2-0.5-3.6-0.9-4.2-1.3c-0.8-0.6-1.2-1.3-1.2-2.3c0-0.9,0.4-1.6,1.1-2.3 c0.7-0.6,1.8-0.9,3.3-0.9c1.4,0,2.5,0.2,3.2,0.7c0.7,0.5,1.2,1.1,1.4,2l-2.6,0.5c-0.1-0.4-0.3-0.7-0.6-0.9 c-0.3-0.2-0.7-0.3-1.3-0.3c-0.7,0-1.2,0.1-1.5,0.3c-0.2,0.1-0.3,0.3-0.3,0.6c0,0.2,0.1,0.4,0.3,0.5c0.2,0.2,1.1,0.4,2.6,0.8 c1.5,0.3,2.5,0.7,3,1.2c0.6,0.5,0.9,1.2,0.9,2c0,0.9-0.4,1.8-1.2,2.4c-0.8,0.7-2,1-3.5,1c-1.4,0-2.5-0.3-3.3-0.9 C37.1,118.6,36.5,117.9,36.3,116.9z\"></path><path d=\"M48.3,108.1v-2.5h2.7v2.5H48.3z M48.3,119.8v-10.3h2.7v10.3H48.3z\"></path><path d=\"M53.2,114.5c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 s1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9c-1,1-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 S53.2,115.7,53.2,114.5z M56,114.7c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8s1.3-0.3,1.8-0.8c0.5-0.5,0.7-1.3,0.7-2.4 c0-1-0.2-1.8-0.7-2.3s-1.1-0.8-1.8-0.8s-1.3,0.3-1.8,0.8S56,113.6,56,114.7z\"></path><path d=\"M75.4,119.8h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7H66v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8c0.3,0.3,0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V119.8z\"></path><path d=\"M83.1,114.5c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 c1,1,1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9s-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 C83.3,116.7,83.1,115.7,83.1,114.5z M85.9,114.7c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8s1.3-0.3,1.8-0.8 c0.5-0.5,0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.7-2.3c-0.5-0.5-1.1-0.8-1.8-0.8s-1.3,0.3-1.8,0.8C86.1,112.9,85.9,113.6,85.9,114.7z\"></path><path d=\"M94.7,109.5h1.5v-0.8c0-0.9,0.1-1.5,0.3-1.9c0.2-0.4,0.5-0.8,1-1c0.5-0.3,1.1-0.4,1.9-0.4c0.8,0,1.5,0.1,2.3,0.4l-0.4,1.9 c-0.4-0.1-0.9-0.2-1.3-0.2c-0.4,0-0.7,0.1-0.9,0.3c-0.2,0.2-0.3,0.5-0.3,1.1v0.7h2v2.1h-2v8.2h-2.7v-8.2h-1.5V109.5z\"></path><path d=\"M107.3,115.2l2.8-0.3c0.2,0.9,0.5,1.6,1,2.1s1.2,0.7,2.1,0.7c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.7-0.9,0.7-1.4 c0-0.3-0.1-0.6-0.3-0.9s-0.5-0.4-1-0.6c-0.3-0.1-1.1-0.3-2.3-0.6c-1.5-0.4-2.6-0.9-3.2-1.4c-0.9-0.8-1.3-1.7-1.3-2.9 c0-0.7,0.2-1.4,0.6-2c0.4-0.6,1-1.1,1.8-1.4c0.8-0.3,1.7-0.5,2.8-0.5c1.8,0,3.1,0.4,4,1.2c0.9,0.8,1.4,1.8,1.4,3.1l-2.9,0.1 c-0.1-0.7-0.4-1.3-0.8-1.6s-1-0.5-1.8-0.5c-0.8,0-1.5,0.2-2,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.9 c0.4,0.3,1.2,0.6,2.6,1c1.4,0.3,2.4,0.7,3.1,1c0.7,0.4,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.3c0,0.8-0.2,1.6-0.7,2.3 c-0.5,0.7-1.1,1.2-1.9,1.6c-0.8,0.3-1.9,0.5-3.1,0.5c-1.8,0-3.2-0.4-4.2-1.2C108.1,118,107.5,116.8,107.3,115.2z\"></path><path d=\"M128.1,119.8v-1.5c-0.4,0.6-0.9,1-1.5,1.3c-0.6,0.3-1.3,0.5-1.9,0.5c-0.7,0-1.3-0.2-1.9-0.5c-0.6-0.3-0.9-0.7-1.2-1.3 c-0.2-0.6-0.4-1.3-0.4-2.3v-6.5h2.7v4.7c0,1.5,0.1,2.3,0.2,2.7c0.1,0.3,0.3,0.6,0.5,0.8c0.3,0.2,0.6,0.3,1,0.3 c0.5,0,0.9-0.1,1.3-0.4c0.4-0.3,0.6-0.6,0.8-1c0.1-0.4,0.2-1.3,0.2-2.8v-4.4h2.7v10.3H128.1z\"></path><path d=\"M136.1,119.8h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4s0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3s-0.5,0.6-0.6,1.1c-0.2,0.6-0.2,1.7-0.2,3.5V119.8z\"></path><path d=\"M141,120.5l3.1,0.4c0.1,0.4,0.2,0.6,0.4,0.7c0.3,0.2,0.7,0.3,1.2,0.3c0.7,0,1.2-0.1,1.6-0.3c0.2-0.1,0.4-0.4,0.5-0.7 c0.1-0.2,0.1-0.6,0.1-1.3v-1.5c-0.8,1.1-1.8,1.7-3.1,1.7c-1.4,0-2.5-0.6-3.3-1.8c-0.6-0.9-1-2.1-1-3.5c0-1.7,0.4-3.1,1.2-4 s1.9-1.4,3.1-1.4c1.3,0,2.3,0.6,3.2,1.7v-1.4h2.6v9.3c0,1.2-0.1,2.1-0.3,2.7c-0.2,0.6-0.5,1.1-0.8,1.4c-0.4,0.3-0.8,0.6-1.5,0.8 c-0.6,0.2-1.4,0.3-2.3,0.3c-1.8,0-3-0.3-3.7-0.9c-0.7-0.6-1.1-1.4-1.1-2.3C141,120.8,141,120.6,141,120.5z M143.4,114.5 c0,1.1,0.2,1.9,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.7-0.8c0.5-0.5,0.7-1.3,0.7-2.3c0-1.1-0.2-1.9-0.7-2.4 c-0.4-0.5-1-0.8-1.7-0.8c-0.7,0-1.2,0.3-1.6,0.8S143.4,113.4,143.4,114.5z\"></path><path d=\"M159.4,116.5l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5s1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4S159.2,117.1,159.4,116.5z M159.5,113.8c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H159.5z\"></path><path d=\"M167.1,119.8h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4c0.3-0.2,0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.6-0.6,1.1c-0.2,0.6-0.2,1.7-0.2,3.5V119.8z\"></path><path d=\"M170.9,109.5h2.9l2.5,7.3l2.4-7.3h2.8l-3.6,9.9l-0.7,1.8c-0.2,0.6-0.5,1.1-0.7,1.4s-0.5,0.6-0.7,0.8 c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.9,0.2-1.4,0.2c-0.5,0-1-0.1-1.5-0.2l-0.2-2.1c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.1-0.2,1.4-0.6 c0.3-0.4,0.5-0.8,0.7-1.4L170.9,109.5z\"></path><path d=\"M2.8,136.6l-2.5-0.4c0.3-1,0.8-1.7,1.4-2.2c0.7-0.5,1.7-0.7,3-0.7c1.2,0,2.1,0.1,2.7,0.4c0.6,0.3,1,0.7,1.3,1.1 c0.2,0.4,0.4,1.3,0.4,2.4l0,3.2c0,0.9,0,1.6,0.1,2c0.1,0.4,0.3,0.9,0.5,1.4H7c-0.1-0.2-0.2-0.5-0.3-0.8c0-0.2-0.1-0.3-0.1-0.3 c-0.5,0.5-1,0.8-1.5,1S4,144,3.4,144c-1.1,0-1.9-0.3-2.5-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-0.6,0.1-1.1,0.4-1.6 c0.3-0.5,0.7-0.8,1.2-1.1c0.5-0.2,1.2-0.5,2.2-0.6c1.3-0.2,2.2-0.5,2.7-0.7v-0.3c0-0.5-0.1-0.9-0.4-1.1c-0.3-0.2-0.7-0.3-1.5-0.3 c-0.5,0-0.9,0.1-1.1,0.3C3.2,135.7,2.9,136.1,2.8,136.6z M6.4,138.8c-0.4,0.1-0.9,0.3-1.7,0.4c-0.8,0.2-1.3,0.3-1.5,0.5 c-0.4,0.3-0.5,0.6-0.5,1c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.5c0.3-0.2,0.5-0.5,0.7-0.9 c0.1-0.2,0.1-0.7,0.1-1.3V138.8z\"></path><path d=\"M21.2,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 s-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.1,0.8 s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M33.4,143.7h-2.5v-1.5c-0.4,0.6-0.9,1-1.5,1.3c-0.6,0.3-1.2,0.4-1.7,0.4c-1.2,0-2.2-0.5-3-1.4c-0.8-1-1.3-2.3-1.3-4 c0-1.8,0.4-3.1,1.2-4c0.8-0.9,1.9-1.4,3.1-1.4c1.2,0,2.2,0.5,3,1.4v-5.1h2.7V143.7z M26.1,138.3c0,1.1,0.2,1.9,0.5,2.4 c0.4,0.7,1.1,1.1,1.8,1.1c0.6,0,1.2-0.3,1.6-0.8c0.4-0.5,0.7-1.3,0.7-2.4c0-1.2-0.2-2-0.6-2.6c-0.4-0.5-1-0.8-1.6-0.8 c-0.6,0-1.2,0.3-1.6,0.8C26.4,136.6,26.1,137.3,26.1,138.3z\"></path><path d=\"M41.6,143.7v-14.3h2.9v14.3H41.6z\"></path><path d=\"M56.6,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2s-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M64.1,133.4v2.2h-1.9v4.2c0,0.8,0,1.3,0.1,1.5c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,1.1-0.3 l0.2,2.1c-0.6,0.3-1.4,0.4-2.2,0.4c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-0.9-0.6c-0.2-0.3-0.3-0.6-0.4-1.1 c-0.1-0.3-0.1-1-0.1-1.9v-4.5h-1.3v-2.2h1.3v-2.1l2.7-1.6v3.6H64.1z\"></path><path d=\"M72,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3s-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7H68c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C71.6,141.3,71.8,141,72,140.4z M72.1,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H72.1z\"></path><path d=\"M79.7,143.7h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4s0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.6-0.6,1.1s-0.2,1.7-0.2,3.5V143.7z\"></path><path d=\"M87.7,143.7l-4.2-10.3h2.9l1.9,5.3l0.6,1.8c0.1-0.4,0.2-0.7,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.9l2-5.3h2.8l-4.1,10.3H87.7z\"></path><path d=\"M101.9,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C101.5,141.3,101.7,141,101.9,140.4z M102,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H102z\"></path><path d=\"M116.4,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 s0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M123.9,133.4v2.2H122v4.2c0,0.8,0,1.3,0.1,1.5c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,1.1-0.3 l0.2,2.1c-0.6,0.3-1.4,0.4-2.2,0.4c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-0.9-0.6c-0.2-0.3-0.3-0.6-0.4-1.1 c-0.1-0.3-0.1-1-0.1-1.9v-4.5H118v-2.2h1.3v-2.1l2.7-1.6v3.6H123.9z\"></path><path d=\"M125.8,132v-2.5h2.7v2.5H125.8z M125.8,143.7v-10.3h2.7v10.3H125.8z\"></path><path d=\"M130.7,138.4c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 c1,1,1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9c-1,1-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 C130.9,140.6,130.7,139.6,130.7,138.4z M133.5,138.6c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8c0.7,0,1.3-0.3,1.8-0.8 s0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.7-2.3s-1.1-0.8-1.8-0.8c-0.7,0-1.3,0.3-1.8,0.8C133.7,136.8,133.5,137.5,133.5,138.6z\"></path><path d=\"M152.9,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2s-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1s0.2,1,0.2,1.8V143.7z\"></path><path d=\"M157.7,136.6l-2.5-0.4c0.3-1,0.8-1.7,1.4-2.2c0.7-0.5,1.7-0.7,3-0.7c1.2,0,2.1,0.1,2.7,0.4c0.6,0.3,1,0.7,1.3,1.1 s0.4,1.3,0.4,2.4l0,3.2c0,0.9,0,1.6,0.1,2c0.1,0.4,0.3,0.9,0.5,1.4h-2.7c-0.1-0.2-0.2-0.5-0.3-0.8c0-0.2-0.1-0.3-0.1-0.3 c-0.5,0.5-1,0.8-1.5,1c-0.5,0.2-1.1,0.3-1.7,0.3c-1.1,0-1.9-0.3-2.5-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-0.6,0.1-1.1,0.4-1.6 c0.3-0.5,0.7-0.8,1.2-1.1c0.5-0.2,1.2-0.5,2.2-0.6c1.3-0.2,2.2-0.5,2.7-0.7v-0.3c0-0.5-0.1-0.9-0.4-1.1s-0.7-0.3-1.5-0.3 c-0.5,0-0.9,0.1-1.1,0.3C158.1,135.7,157.8,136.1,157.7,136.6z M161.3,138.8c-0.4,0.1-0.9,0.3-1.7,0.4c-0.8,0.2-1.3,0.3-1.5,0.5 c-0.4,0.3-0.5,0.6-0.5,1c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.5c0.3-0.2,0.5-0.5,0.7-0.9 c0.1-0.2,0.1-0.7,0.1-1.3V138.8z\"></path><path d=\"M166.7,143.7v-14.3h2.7v14.3H166.7z\"></path><path d=\"M177.1,139.1l2.8-0.3c0.2,0.9,0.5,1.6,1,2.1c0.5,0.4,1.2,0.7,2.1,0.7c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.7-0.9,0.7-1.4 c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.2-0.5-0.4-1-0.6c-0.3-0.1-1.1-0.3-2.3-0.6c-1.5-0.4-2.6-0.9-3.2-1.4c-0.9-0.8-1.3-1.7-1.3-2.9 c0-0.7,0.2-1.4,0.6-2s1-1.1,1.8-1.4c0.8-0.3,1.7-0.5,2.8-0.5c1.8,0,3.1,0.4,4,1.2c0.9,0.8,1.4,1.8,1.4,3.1l-2.9,0.1 c-0.1-0.7-0.4-1.3-0.8-1.6s-1-0.5-1.8-0.5c-0.8,0-1.5,0.2-2,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.9 c0.4,0.3,1.2,0.6,2.6,1c1.4,0.3,2.4,0.7,3.1,1c0.7,0.4,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.3c0,0.8-0.2,1.6-0.7,2.3 c-0.5,0.7-1.1,1.2-1.9,1.6s-1.9,0.5-3.1,0.5c-1.8,0-3.2-0.4-4.2-1.2C177.8,141.9,177.2,140.7,177.1,139.1z\"></path><path d=\"M200,136.5l-2.7,0.5c-0.1-0.5-0.3-0.9-0.6-1.2s-0.7-0.4-1.2-0.4c-0.7,0-1.2,0.2-1.6,0.7s-0.6,1.3-0.6,2.4 c0,1.2,0.2,2.1,0.6,2.6c0.4,0.5,1,0.8,1.7,0.8c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.6-0.8,0.7-1.5l2.7,0.5c-0.3,1.2-0.8,2.2-1.6,2.8 s-1.9,0.9-3.2,0.9c-1.5,0-2.7-0.5-3.6-1.4s-1.3-2.3-1.3-4c0-1.7,0.5-3,1.4-4c0.9-1,2.1-1.4,3.7-1.4c1.3,0,2.3,0.3,3,0.8 C199.2,134.5,199.7,135.4,200,136.5z\"></path><path d=\"M202.1,132v-2.5h2.7v2.5H202.1z M202.1,143.7v-10.3h2.7v10.3H202.1z\"></path><path d=\"M213.6,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C213.3,141.3,213.5,141,213.6,140.4z M213.8,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7s-0.6,1-0.6,1.8H213.8z\"></path><path d=\"M228.1,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 s-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3s0.9,0.5,1.1,0.8 s0.4,0.7,0.5,1.1s0.2,1,0.2,1.8V143.7z\"></path><path d=\"M239.9,136.5l-2.7,0.5c-0.1-0.5-0.3-0.9-0.6-1.2s-0.7-0.4-1.2-0.4c-0.7,0-1.2,0.2-1.6,0.7s-0.6,1.3-0.6,2.4 c0,1.2,0.2,2.1,0.6,2.6c0.4,0.5,1,0.8,1.7,0.8c0.5,0,0.9-0.1,1.3-0.4s0.6-0.8,0.7-1.5l2.7,0.5c-0.3,1.2-0.8,2.2-1.6,2.8 s-1.9,0.9-3.2,0.9c-1.5,0-2.7-0.5-3.6-1.4c-0.9-1-1.3-2.3-1.3-4c0-1.7,0.5-3,1.4-4c0.9-1,2.1-1.4,3.7-1.4c1.3,0,2.3,0.3,3,0.8 C239,134.5,239.6,135.4,239.9,136.5z\"></path><path d=\"M247.9,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7H244c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C247.6,141.3,247.8,141,247.9,140.4z M248.1,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H248.1z\"></path></g></svg></i> <i class=\"icon-logo logo-black\" ng-show=\"black\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 300 150\" enable-background=\"new 0 0 300 150\" xml:space=\"preserve\"><g><path d=\"M84.8,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0v0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2H84.8z\"></path><path d=\"M86.4,49v0.3c0,0,0,0,0,0l0,0l0,0l0,0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h1.9c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1 c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49H86.4z\"></path><path d=\"M79.4,49.3C79.4,49.3,79.4,49.3,79.4,49.3L79.4,49.3L79.4,49.3c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h1.9c0,0,0-0.2,0-0.2c0,0,0,0,0,0 h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0 c0,0,0,0,0,0V49h-1.8V49.3z\"></path><path d=\"M74.3,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0 c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0l0,0l-0.1,0 c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0 c0,0,0,0.1,0,0.2H74.3z\"></path><path d=\"M77.8,56.6c0,0,0-0.2,0-0.2c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 v-6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49h-1.8v0.3c0,0,0,0,0,0v0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4 c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2H77.8z\"></path><path d=\"M1.3,4v87.7l108.5,0c-0.8-0.6-1.6-1.2-2.3-1.9c-6.2-6-6.3-13-6.5-19.5v-37h19.8v38.9c0,2.6,0.1,5.4,2.3,7.5 c1.6,1.7,4,2.3,6.3,2.3c3.1,0,5.1-1.1,6.3-2.2c2.3-2.2,2.4-4.9,2.4-7.6V33.4H158v33.1c0,7.1,0,16.4-7.3,23.4 c-0.7,0.7-1.5,1.3-2.3,1.9h29.7c-8.7-6.3-12.8-16.8-12.8-26.9c0-16.7,11.2-33.8,32.4-33.8c9.5,0,18.5,3.4,25.1,10.1 c2.7,2.7,3.9,4.8,5.2,7.3l-16.6,8.2c-1.6-3.7-4.6-10.3-12.9-10.3c-4.3,0-7.1,2-8.4,3.4c-4.7,4.5-4.7,11.5-4.7,14 c0,9.3,3.5,18,13.2,18c9.2,0,12-8.1,12.7-10.2l16.8,8.1c-1.6,3-3.1,5.8-6.1,8.8c-1.3,1.3-2.7,2.4-4.2,3.4h18.2V33.3h19.7v46h25.6 v12.5l18.7,0V4H1.3z M75.3,43C75.3,43,75.4,43,75.3,43c0,0,0.2,0,0.2,0c0,0,0,0,0,0s0-0.1,0-0.2c0,0,0,0,0,0s0.1,0,0.2,0 c0,0,0,0,0,0v-0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0-0.2-0.1-1.8,0.8-3c0.7-1,1.6-1.5,2.1-1.7 c0-0.2,0.3-0.3,0.4-0.3c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0v-0.2c0,0,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.1v-1.2c0,0,0,0-0.1,0c0,0,0,0,0,0h0c0,0,0,0,0,0v-0.1 c0,0,0,0,0,0h0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1h0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0h0.1c0,0,0,0,0.1,0c0.2-0.2,0.4-0.4,0.4-0.4 c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0.1,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0.1-0.2,0.1-0.2h0c0,0,0.1,0.1,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0.2,0.3,0.4,0.4c0,0,0,0,0.1,0h0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0h0c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.1h0.1c0,0,0,0,0,0v0.1c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0-0.1,0-0.1,0v1.2 c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1V37c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0.1 c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.4,0.1,0.5,0.3c0.5,0.2,1.4,0.7,2.1,1.7c0.8,1.2,0.8,2.8,0.8,3c0,0,0,0.1,0.1,0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0,0v0.2c0,0,0,0,0,0c0,0,0.2,0,0.2,0s0,0,0,0c0,0,0,0.2,0,0.2s0,0,0,0c0,0,0.2,0,0.2,0h0c0,0,0,0,0,0 c0,0,0,0.1,0,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.2c0,0.2-0.1,0.2-0.2,0.2v0.7c0,0.2,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0,0,0,0.7,0,0.7 l-4.9-1.1h0l-4.9,1.1c0,0,0-0.7,0-0.7c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2v-0.7c0,0-0.2,0-0.2-0.2c0-0.1-0.1-0.2-0.2-0.2 c0,0,0,0,0,0C75.3,43.2,75.3,43.1,75.3,43z M91.5,60.1l-22.5,0v-1.4h0.8v-1.4h0.8v-0.6c0,0,0,0,0,0c0,0,0-0.2,0-0.2c0,0,0,0,0,0 h0.1c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v-6c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1l-0.1,0c0,0,0,0,0,0V49 h-0.1c0,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.1-0.1L70,48.1c-0.1-0.2-0.3-0.1-0.3-0.1l0,0l0,0l-0.1-0.5c0,0,0,0,0-0.1 c0,0,10.7-2.3,10.7-2.3S91,47.3,91,47.3h0c0.1,0,0,0.1,0,0.1l-0.1,0.5l0,0l0,0c0,0-0.2,0-0.3,0.1L90.4,49c0,0,0,0-0.1,0 c-0.1,0-0.4,0-0.4,0h-0.1v0.3c0,0,0,0,0,0h0l0,0l0,0l-0.1,0c0,0,0,0,0,0.1c0,0,0,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0 v0.1c0,0,0,0,0,0c0,0,0,0,0,0h0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.2h0v0.6h0.8v1.4h0.8V60.1z\"></path></g><g><path d=\"M0.7,105.6H6c1.2,0,2.1,0.1,2.7,0.3c0.8,0.2,1.6,0.7,2.1,1.3c0.6,0.6,1.1,1.4,1.4,2.3c0.3,0.9,0.5,2,0.5,3.4 c0,1.2-0.1,2.2-0.4,3c-0.4,1-0.9,1.9-1.5,2.5c-0.5,0.5-1.2,0.9-2,1.1c-0.6,0.2-1.5,0.3-2.5,0.3H0.7V105.6z M3.6,108v9.4h2.1 c0.8,0,1.4,0,1.7-0.1c0.5-0.1,0.9-0.3,1.2-0.6c0.3-0.3,0.6-0.7,0.8-1.4c0.2-0.6,0.3-1.5,0.3-2.6s-0.1-1.9-0.3-2.5s-0.5-1.1-0.8-1.4 s-0.8-0.6-1.3-0.7C6.9,108,6.1,108,4.9,108H3.6z\"></path><path d=\"M15.1,108.1v-2.5h2.7v2.5H15.1z M15.1,119.8v-10.3h2.7v10.3H15.1z\"></path><path d=\"M23.5,119.8l-4.2-10.3h2.9l1.9,5.3l0.6,1.8c0.1-0.4,0.2-0.7,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.9l2-5.3H30l-4.1,10.3H23.5z\"></path><path d=\"M31.7,108.1v-2.5h2.7v2.5H31.7z M31.7,119.8v-10.3h2.7v10.3H31.7z\"></path><path d=\"M36.3,116.9l2.7-0.4c0.1,0.5,0.4,0.9,0.7,1.2c0.4,0.3,0.9,0.4,1.5,0.4c0.7,0,1.2-0.1,1.6-0.4c0.2-0.2,0.4-0.4,0.4-0.7 c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.4-0.2-0.9-0.4c-2.2-0.5-3.6-0.9-4.2-1.3c-0.8-0.6-1.2-1.3-1.2-2.3c0-0.9,0.4-1.6,1.1-2.3 c0.7-0.6,1.8-0.9,3.3-0.9c1.4,0,2.5,0.2,3.2,0.7c0.7,0.5,1.2,1.1,1.4,2l-2.6,0.5c-0.1-0.4-0.3-0.7-0.6-0.9 c-0.3-0.2-0.7-0.3-1.3-0.3c-0.7,0-1.2,0.1-1.5,0.3c-0.2,0.1-0.3,0.3-0.3,0.6c0,0.2,0.1,0.4,0.3,0.5c0.2,0.2,1.1,0.4,2.6,0.8 c1.5,0.3,2.5,0.7,3,1.2c0.6,0.5,0.9,1.2,0.9,2c0,0.9-0.4,1.8-1.2,2.4c-0.8,0.7-2,1-3.5,1c-1.4,0-2.5-0.3-3.3-0.9 C37.1,118.6,36.5,117.9,36.3,116.9z\"></path><path d=\"M48.3,108.1v-2.5h2.7v2.5H48.3z M48.3,119.8v-10.3h2.7v10.3H48.3z\"></path><path d=\"M53.2,114.5c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 s1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9c-1,1-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 S53.2,115.7,53.2,114.5z M56,114.7c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8s1.3-0.3,1.8-0.8c0.5-0.5,0.7-1.3,0.7-2.4 c0-1-0.2-1.8-0.7-2.3s-1.1-0.8-1.8-0.8s-1.3,0.3-1.8,0.8S56,113.6,56,114.7z\"></path><path d=\"M75.4,119.8h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7H66v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8c0.3,0.3,0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V119.8z\"></path><path d=\"M83.1,114.5c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 c1,1,1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9s-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 C83.3,116.7,83.1,115.7,83.1,114.5z M85.9,114.7c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8s1.3-0.3,1.8-0.8 c0.5-0.5,0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.7-2.3c-0.5-0.5-1.1-0.8-1.8-0.8s-1.3,0.3-1.8,0.8C86.1,112.9,85.9,113.6,85.9,114.7z\"></path><path d=\"M94.7,109.5h1.5v-0.8c0-0.9,0.1-1.5,0.3-1.9c0.2-0.4,0.5-0.8,1-1c0.5-0.3,1.1-0.4,1.9-0.4c0.8,0,1.5,0.1,2.3,0.4l-0.4,1.9 c-0.4-0.1-0.9-0.2-1.3-0.2c-0.4,0-0.7,0.1-0.9,0.3c-0.2,0.2-0.3,0.5-0.3,1.1v0.7h2v2.1h-2v8.2h-2.7v-8.2h-1.5V109.5z\"></path><path d=\"M107.3,115.2l2.8-0.3c0.2,0.9,0.5,1.6,1,2.1s1.2,0.7,2.1,0.7c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.7-0.9,0.7-1.4 c0-0.3-0.1-0.6-0.3-0.9s-0.5-0.4-1-0.6c-0.3-0.1-1.1-0.3-2.3-0.6c-1.5-0.4-2.6-0.9-3.2-1.4c-0.9-0.8-1.3-1.7-1.3-2.9 c0-0.7,0.2-1.4,0.6-2c0.4-0.6,1-1.1,1.8-1.4c0.8-0.3,1.7-0.5,2.8-0.5c1.8,0,3.1,0.4,4,1.2c0.9,0.8,1.4,1.8,1.4,3.1l-2.9,0.1 c-0.1-0.7-0.4-1.3-0.8-1.6s-1-0.5-1.8-0.5c-0.8,0-1.5,0.2-2,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.9 c0.4,0.3,1.2,0.6,2.6,1c1.4,0.3,2.4,0.7,3.1,1c0.7,0.4,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.3c0,0.8-0.2,1.6-0.7,2.3 c-0.5,0.7-1.1,1.2-1.9,1.6c-0.8,0.3-1.9,0.5-3.1,0.5c-1.8,0-3.2-0.4-4.2-1.2C108.1,118,107.5,116.8,107.3,115.2z\"></path><path d=\"M128.1,119.8v-1.5c-0.4,0.6-0.9,1-1.5,1.3c-0.6,0.3-1.3,0.5-1.9,0.5c-0.7,0-1.3-0.2-1.9-0.5c-0.6-0.3-0.9-0.7-1.2-1.3 c-0.2-0.6-0.4-1.3-0.4-2.3v-6.5h2.7v4.7c0,1.5,0.1,2.3,0.2,2.7c0.1,0.3,0.3,0.6,0.5,0.8c0.3,0.2,0.6,0.3,1,0.3 c0.5,0,0.9-0.1,1.3-0.4c0.4-0.3,0.6-0.6,0.8-1c0.1-0.4,0.2-1.3,0.2-2.8v-4.4h2.7v10.3H128.1z\"></path><path d=\"M136.1,119.8h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4s0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3s-0.5,0.6-0.6,1.1c-0.2,0.6-0.2,1.7-0.2,3.5V119.8z\"></path><path d=\"M141,120.5l3.1,0.4c0.1,0.4,0.2,0.6,0.4,0.7c0.3,0.2,0.7,0.3,1.2,0.3c0.7,0,1.2-0.1,1.6-0.3c0.2-0.1,0.4-0.4,0.5-0.7 c0.1-0.2,0.1-0.6,0.1-1.3v-1.5c-0.8,1.1-1.8,1.7-3.1,1.7c-1.4,0-2.5-0.6-3.3-1.8c-0.6-0.9-1-2.1-1-3.5c0-1.7,0.4-3.1,1.2-4 s1.9-1.4,3.1-1.4c1.3,0,2.3,0.6,3.2,1.7v-1.4h2.6v9.3c0,1.2-0.1,2.1-0.3,2.7c-0.2,0.6-0.5,1.1-0.8,1.4c-0.4,0.3-0.8,0.6-1.5,0.8 c-0.6,0.2-1.4,0.3-2.3,0.3c-1.8,0-3-0.3-3.7-0.9c-0.7-0.6-1.1-1.4-1.1-2.3C141,120.8,141,120.6,141,120.5z M143.4,114.5 c0,1.1,0.2,1.9,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.7-0.8c0.5-0.5,0.7-1.3,0.7-2.3c0-1.1-0.2-1.9-0.7-2.4 c-0.4-0.5-1-0.8-1.7-0.8c-0.7,0-1.2,0.3-1.6,0.8S143.4,113.4,143.4,114.5z\"></path><path d=\"M159.4,116.5l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5s1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4S159.2,117.1,159.4,116.5z M159.5,113.8c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H159.5z\"></path><path d=\"M167.1,119.8h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4c0.3-0.2,0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.6-0.6,1.1c-0.2,0.6-0.2,1.7-0.2,3.5V119.8z\"></path><path d=\"M170.9,109.5h2.9l2.5,7.3l2.4-7.3h2.8l-3.6,9.9l-0.7,1.8c-0.2,0.6-0.5,1.1-0.7,1.4s-0.5,0.6-0.7,0.8 c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.9,0.2-1.4,0.2c-0.5,0-1-0.1-1.5-0.2l-0.2-2.1c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.1-0.2,1.4-0.6 c0.3-0.4,0.5-0.8,0.7-1.4L170.9,109.5z\"></path><path d=\"M2.8,136.6l-2.5-0.4c0.3-1,0.8-1.7,1.4-2.2c0.7-0.5,1.7-0.7,3-0.7c1.2,0,2.1,0.1,2.7,0.4c0.6,0.3,1,0.7,1.3,1.1 c0.2,0.4,0.4,1.3,0.4,2.4l0,3.2c0,0.9,0,1.6,0.1,2c0.1,0.4,0.3,0.9,0.5,1.4H7c-0.1-0.2-0.2-0.5-0.3-0.8c0-0.2-0.1-0.3-0.1-0.3 c-0.5,0.5-1,0.8-1.5,1S4,144,3.4,144c-1.1,0-1.9-0.3-2.5-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-0.6,0.1-1.1,0.4-1.6 c0.3-0.5,0.7-0.8,1.2-1.1c0.5-0.2,1.2-0.5,2.2-0.6c1.3-0.2,2.2-0.5,2.7-0.7v-0.3c0-0.5-0.1-0.9-0.4-1.1c-0.3-0.2-0.7-0.3-1.5-0.3 c-0.5,0-0.9,0.1-1.1,0.3C3.2,135.7,2.9,136.1,2.8,136.6z M6.4,138.8c-0.4,0.1-0.9,0.3-1.7,0.4c-0.8,0.2-1.3,0.3-1.5,0.5 c-0.4,0.3-0.5,0.6-0.5,1c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.5c0.3-0.2,0.5-0.5,0.7-0.9 c0.1-0.2,0.1-0.7,0.1-1.3V138.8z\"></path><path d=\"M21.2,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 s-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.1,0.8 s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M33.4,143.7h-2.5v-1.5c-0.4,0.6-0.9,1-1.5,1.3c-0.6,0.3-1.2,0.4-1.7,0.4c-1.2,0-2.2-0.5-3-1.4c-0.8-1-1.3-2.3-1.3-4 c0-1.8,0.4-3.1,1.2-4c0.8-0.9,1.9-1.4,3.1-1.4c1.2,0,2.2,0.5,3,1.4v-5.1h2.7V143.7z M26.1,138.3c0,1.1,0.2,1.9,0.5,2.4 c0.4,0.7,1.1,1.1,1.8,1.1c0.6,0,1.2-0.3,1.6-0.8c0.4-0.5,0.7-1.3,0.7-2.4c0-1.2-0.2-2-0.6-2.6c-0.4-0.5-1-0.8-1.6-0.8 c-0.6,0-1.2,0.3-1.6,0.8C26.4,136.6,26.1,137.3,26.1,138.3z\"></path><path d=\"M41.6,143.7v-14.3h2.9v14.3H41.6z\"></path><path d=\"M56.6,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2s-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M64.1,133.4v2.2h-1.9v4.2c0,0.8,0,1.3,0.1,1.5c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,1.1-0.3 l0.2,2.1c-0.6,0.3-1.4,0.4-2.2,0.4c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-0.9-0.6c-0.2-0.3-0.3-0.6-0.4-1.1 c-0.1-0.3-0.1-1-0.1-1.9v-4.5h-1.3v-2.2h1.3v-2.1l2.7-1.6v3.6H64.1z\"></path><path d=\"M72,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3s-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7H68c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C71.6,141.3,71.8,141,72,140.4z M72.1,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H72.1z\"></path><path d=\"M79.7,143.7h-2.7v-10.3h2.5v1.5c0.4-0.7,0.8-1.2,1.2-1.4s0.7-0.3,1.2-0.3c0.6,0,1.2,0.2,1.8,0.5l-0.8,2.4 c-0.5-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.6-0.6,1.1s-0.2,1.7-0.2,3.5V143.7z\"></path><path d=\"M87.7,143.7l-4.2-10.3h2.9l1.9,5.3l0.6,1.8c0.1-0.4,0.2-0.7,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.9l2-5.3h2.8l-4.1,10.3H87.7z\"></path><path d=\"M101.9,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C101.5,141.3,101.7,141,101.9,140.4z M102,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H102z\"></path><path d=\"M116.4,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 s0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1c0.1,0.4,0.2,1,0.2,1.8V143.7z\"></path><path d=\"M123.9,133.4v2.2H122v4.2c0,0.8,0,1.3,0.1,1.5c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,1.1-0.3 l0.2,2.1c-0.6,0.3-1.4,0.4-2.2,0.4c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-0.9-0.6c-0.2-0.3-0.3-0.6-0.4-1.1 c-0.1-0.3-0.1-1-0.1-1.9v-4.5H118v-2.2h1.3v-2.1l2.7-1.6v3.6H123.9z\"></path><path d=\"M125.8,132v-2.5h2.7v2.5H125.8z M125.8,143.7v-10.3h2.7v10.3H125.8z\"></path><path d=\"M130.7,138.4c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1.1-1.5,1.9-1.9c0.8-0.4,1.7-0.7,2.7-0.7c1.6,0,2.8,0.5,3.8,1.5 c1,1,1.5,2.3,1.5,3.8c0,1.6-0.5,2.9-1.5,3.9c-1,1-2.3,1.5-3.8,1.5c-0.9,0-1.8-0.2-2.7-0.6c-0.9-0.4-1.5-1.1-2-1.9 C130.9,140.6,130.7,139.6,130.7,138.4z M133.5,138.6c0,1,0.2,1.8,0.7,2.4c0.5,0.5,1.1,0.8,1.8,0.8c0.7,0,1.3-0.3,1.8-0.8 s0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.7-2.3s-1.1-0.8-1.8-0.8c-0.7,0-1.3,0.3-1.8,0.8C133.7,136.8,133.5,137.5,133.5,138.6z\"></path><path d=\"M152.9,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2s-0.3-0.6-0.6-0.8s-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 c-0.4,0.3-0.6,0.6-0.8,1s-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.5,1.1,0.8s0.4,0.7,0.5,1.1s0.2,1,0.2,1.8V143.7z\"></path><path d=\"M157.7,136.6l-2.5-0.4c0.3-1,0.8-1.7,1.4-2.2c0.7-0.5,1.7-0.7,3-0.7c1.2,0,2.1,0.1,2.7,0.4c0.6,0.3,1,0.7,1.3,1.1 s0.4,1.3,0.4,2.4l0,3.2c0,0.9,0,1.6,0.1,2c0.1,0.4,0.3,0.9,0.5,1.4h-2.7c-0.1-0.2-0.2-0.5-0.3-0.8c0-0.2-0.1-0.3-0.1-0.3 c-0.5,0.5-1,0.8-1.5,1c-0.5,0.2-1.1,0.3-1.7,0.3c-1.1,0-1.9-0.3-2.5-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-0.6,0.1-1.1,0.4-1.6 c0.3-0.5,0.7-0.8,1.2-1.1c0.5-0.2,1.2-0.5,2.2-0.6c1.3-0.2,2.2-0.5,2.7-0.7v-0.3c0-0.5-0.1-0.9-0.4-1.1s-0.7-0.3-1.5-0.3 c-0.5,0-0.9,0.1-1.1,0.3C158.1,135.7,157.8,136.1,157.7,136.6z M161.3,138.8c-0.4,0.1-0.9,0.3-1.7,0.4c-0.8,0.2-1.3,0.3-1.5,0.5 c-0.4,0.3-0.5,0.6-0.5,1c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.5c0.3-0.2,0.5-0.5,0.7-0.9 c0.1-0.2,0.1-0.7,0.1-1.3V138.8z\"></path><path d=\"M166.7,143.7v-14.3h2.7v14.3H166.7z\"></path><path d=\"M177.1,139.1l2.8-0.3c0.2,0.9,0.5,1.6,1,2.1c0.5,0.4,1.2,0.7,2.1,0.7c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.7-0.9,0.7-1.4 c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.2-0.5-0.4-1-0.6c-0.3-0.1-1.1-0.3-2.3-0.6c-1.5-0.4-2.6-0.9-3.2-1.4c-0.9-0.8-1.3-1.7-1.3-2.9 c0-0.7,0.2-1.4,0.6-2s1-1.1,1.8-1.4c0.8-0.3,1.7-0.5,2.8-0.5c1.8,0,3.1,0.4,4,1.2c0.9,0.8,1.4,1.8,1.4,3.1l-2.9,0.1 c-0.1-0.7-0.4-1.3-0.8-1.6s-1-0.5-1.8-0.5c-0.8,0-1.5,0.2-2,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.9 c0.4,0.3,1.2,0.6,2.6,1c1.4,0.3,2.4,0.7,3.1,1c0.7,0.4,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.3c0,0.8-0.2,1.6-0.7,2.3 c-0.5,0.7-1.1,1.2-1.9,1.6s-1.9,0.5-3.1,0.5c-1.8,0-3.2-0.4-4.2-1.2C177.8,141.9,177.2,140.7,177.1,139.1z\"></path><path d=\"M200,136.5l-2.7,0.5c-0.1-0.5-0.3-0.9-0.6-1.2s-0.7-0.4-1.2-0.4c-0.7,0-1.2,0.2-1.6,0.7s-0.6,1.3-0.6,2.4 c0,1.2,0.2,2.1,0.6,2.6c0.4,0.5,1,0.8,1.7,0.8c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.6-0.8,0.7-1.5l2.7,0.5c-0.3,1.2-0.8,2.2-1.6,2.8 s-1.9,0.9-3.2,0.9c-1.5,0-2.7-0.5-3.6-1.4s-1.3-2.3-1.3-4c0-1.7,0.5-3,1.4-4c0.9-1,2.1-1.4,3.7-1.4c1.3,0,2.3,0.3,3,0.8 C199.2,134.5,199.7,135.4,200,136.5z\"></path><path d=\"M202.1,132v-2.5h2.7v2.5H202.1z M202.1,143.7v-10.3h2.7v10.3H202.1z\"></path><path d=\"M213.6,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7h-6.8c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C213.3,141.3,213.5,141,213.6,140.4z M213.8,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7s-0.6,1-0.6,1.8H213.8z\"></path><path d=\"M228.1,143.7h-2.7v-5.3c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.9,0.1-1.3,0.4 s-0.6,0.6-0.8,1c-0.1,0.4-0.2,1.2-0.2,2.4v4.7h-2.7v-10.3h2.5v1.5c0.9-1.2,2-1.8,3.4-1.8c0.6,0,1.2,0.1,1.7,0.3s0.9,0.5,1.1,0.8 s0.4,0.7,0.5,1.1s0.2,1,0.2,1.8V143.7z\"></path><path d=\"M239.9,136.5l-2.7,0.5c-0.1-0.5-0.3-0.9-0.6-1.2s-0.7-0.4-1.2-0.4c-0.7,0-1.2,0.2-1.6,0.7s-0.6,1.3-0.6,2.4 c0,1.2,0.2,2.1,0.6,2.6c0.4,0.5,1,0.8,1.7,0.8c0.5,0,0.9-0.1,1.3-0.4s0.6-0.8,0.7-1.5l2.7,0.5c-0.3,1.2-0.8,2.2-1.6,2.8 s-1.9,0.9-3.2,0.9c-1.5,0-2.7-0.5-3.6-1.4c-0.9-1-1.3-2.3-1.3-4c0-1.7,0.5-3,1.4-4c0.9-1,2.1-1.4,3.7-1.4c1.3,0,2.3,0.3,3,0.8 C239,134.5,239.6,135.4,239.9,136.5z\"></path><path d=\"M247.9,140.4l2.7,0.5c-0.4,1-0.9,1.8-1.7,2.3c-0.8,0.5-1.7,0.8-2.8,0.8c-1.8,0-3.1-0.6-4-1.8c-0.7-0.9-1-2.1-1-3.6 c0-1.7,0.4-3.1,1.3-4c0.9-1,2-1.5,3.4-1.5c1.5,0,2.7,0.5,3.6,1.5c0.9,1,1.3,2.6,1.3,4.7H244c0,0.8,0.2,1.4,0.7,1.9 c0.4,0.5,0.9,0.7,1.6,0.7c0.4,0,0.8-0.1,1.1-0.4C247.6,141.3,247.8,141,247.9,140.4z M248.1,137.7c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8H248.1z\"></path></g></svg></i></div></a></h1><div id=\"procedure-info\" ng-show=\"showprocedure\"><a ng-href=\"#\" ui-sref=\"app.info\" class=\"\"><span>About the procedure</span><button class=\"icon-border\"><i class=\"ucl-plus\"></i></button></a></div><a class=\"closeBtn\" ng-show=\"showclose\" ng-click=\"goBack()\"><span>Close</span><button class=\"icon-border\"><i class=\"ucl-close\"></i></button></a></div></div>");
$templateCache.put("app/components/scrollindicator/scrollindicator.html","<div class=\"scroll-indicator-wrapper\"><div class=\"scroll-indicator-holder\"><ol class=\"orbit-bullets\"><scroll-indicator-button ng-repeat=\"section in scrollData\" id=\"{{$index}}\" section=\"section.section\" ng-class=\"{active: index == $index}\" ng-click=\"goto($index)\"></scroll-indicator-button></ol></div></div>");
$templateCache.put("app/components/videoplayer/videoplayer.html","<div class=\"video-holder\"><videogular vg-player-ready=\"main.onPlayerReady($API)\" vg-update-time=\"main.onUpdate($currentTime, $duration)\" vg-complete=\"main.onCompleteVideo()\" vg-update-state=\"main.onStateChange($state)\" vg-bkg-size=\"{{main.scalemode}}\" center=\"true\" vg-auto-play=\"config.autoPlay\"><vg-media vg-src=\"config.sources\" vg-native-controls=\"false\"></vg-media><vg-controls vg-autohide=\"config.plugins.controls.autoHide\" vg-autohide-time=\"config.plugins.controls.autoHideTime\" ng-if=\"main.other\"><vg-play-pause-button></vg-play-pause-button><vg-time-display class=\"p-l\">{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-time-display class=\"p-r\">{{ timeLeft | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button></vg-volume></vg-controls><vg-buffering></vg-buffering><vg-poster vg-url=\"config.plugins.poster\" ng-if=\"main.other\"></vg-poster></videogular></div>");
$templateCache.put("app/components/videoplayer/videoplayerinterface.html","<div id=\"interface-wrapper\" class=\"close\" ng-class=\"nclass\"><div id=\"info-button\"><button class=\"button trans round\" name=\"info\" ng-click=\"openInfo()\"><i class=\"ucl-info\"></i></button></div><video-popover-view state=\"nclass\"></video-popover-view><div class=\"interface-slider\"><div class=\"interface-holder\" ng-mouseenter=\"open()\" ng-mouseover=\"open()\" ng-mouseleave=\"close(e)\"><div class=\"currentTitle\">Now Playing: {{ title }}</div><video-player-seekbar></video-player-seekbar><video-player-list></video-player-list></div></div></div>");
$templateCache.put("app/components/videoplayer/videoplayerlist.html","<div class=\"video-list\"><ul class=\"small-block-grid-{{main.videos.length}} small-padding\"><li ng-repeat=\"video in main.videos\" ng-click=\"main.openVideo(video.id)\" id=\"video_bt_{{ video.id }}\" class=\"video-list-item\"><div class=\"image-wrapper\"><div class=\"video-name\"><p>{{video.name}}</p></div><img ng-src=\"{{main.getImageUrl(video.source.thumb)}}\" alt=\"\"></div></li></ul></div>");
$templateCache.put("app/components/videoplayer/videoplayermobilelist.html","<div class=\"video-list-mobile\"><ul class=\"small-block-grid-1 video-list\"><li id=\"video_{{ $index }}\" class=\"video-item\" ng-repeat=\"item in main.videos\"><div ng-click=\"main.openVideo($index)\"><div class=\"image\"><img ng-src=\"{{main.getImageUrl(item.source.mob)}}\" alt=\"\"></div><div class=\"header\">{{ item.name }}</div></div><div class=\"info-button\"><button id=\"info_{{ $index }}\" class=\"button trans round icon-border\" ng-click=\"main.openInfo($index)\" name=\"info\"><i class=\"ucl-info\"></i></button></div><div class=\"info-button2\" ng-click=\"main.openVideo($index)\"><div class=\"button trans round icon-border\"><i class=\"ucl-play\"></i></div></div></li></ul></div>");
$templateCache.put("app/components/videoplayer/videoplayerseekinfopopup.html","<div class=\"info-points\" ng-style=\"{left: style + \'%\'}\"></div>");
$templateCache.put("app/components/videoplayer/videopopoverview.html","<div id=\"popoverview\"><div class=\"pointer\"></div><div class=\"pop-holder\"><div class=\"content\"><div class=\"image small-2\"></div><div class=\"content small-12\"><h3>{{header}}</h3><p>{{content}}</p></div></div></div></div>");
$templateCache.put("app/components/orientation/landscape-overlay.html","<div class=\"row\"><div class=\"small-4 small-offset-4 column mb\"><img src=\"/assets/images/device-rotate.png\" alt=\"\"></div><div class=\"small-12 column\">You need to switch your mobile device to portrait orientation to view the website.</div></div>");}]);